import React from "react";
import type { CollapseProps } from "antd";
import { Collapse, Drawer } from "antd";
import {
  EditOutlined,
  LoadingOutlined,
  PlusOutlined,
  SaveOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import {
  Button,
  Card,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  Row,
  Select,
  Space,
  Spin,
  Tag,
} from "antd";
import deleteImg from "../../../../images/deletebutton.svg";
import { useContext, useEffect, useRef, useState } from "react";
import { Utils } from "../../../../Utilities/Utils";
import { ConfirmationModal } from "../../../Common/ConfirmationModal";
import { useClient } from "../../../Context/ClientContext";
import { dayjs } from "../../../../Utilities/dayjs";
import { ISelectGroup } from "../../../../Types/CommonTypes";
import { notificationContext } from "../../../Common/Routing/PageRoute";
import LedgerService, {
  SearchLedgerByGroupsTypes,
} from "../../../Services/LedgerService";
import VoucherServices, {
  OpeningEntry_Categories,
  Party_Tax,
  Voucher_Type,
  VoucherMode,
} from "../../../Services/VoucherServices";
import AddLedger from "../../Master/Ledger/AddLedger";
import ImportPartyModal from "../../Parties/ImportPartyModal";
import "../../../Common/Acc_Common.css";
import AddItems from "../../Items/AddItems";
import Items from "../../Items/ItemTable";
import ItemsService, {
  IOpeningEntryItemsList,
  Item_Nature,
  ItemAdd_Type,
  ItemType,
} from "../../../Services/ItemsService";
import {
  findUserOnlyOnePremission,
  findUserPremission,
} from "../../Users/Roles/UserSecurityFind";
import { useUser } from "../../../../Context/UserContext";
import { SettingsSections } from "../../../Services/SettingService";
import { IPermissionActionType } from "../../Users/Roles/UserPermissionCommonData";
import { ITypeIIsClientSpecificRoleDataType } from "../../../../Context/RoleContext";
import AddAssetItems from "../../Assets/Items/AddAssetItems";
import AssteItemsTable from "../../Assets/Items/AssteItemsTable";
import AssetChildItemsTable from "../../Assets/Items/AssetChildItemsTable";

const SettingOpeningBalanceNew: React.FC = () => {
  //form according to blocks
  const [creditorform] = Form.useForm();
  const [debitorForm] = Form.useForm();
  const [dateForm] = Form.useForm();
  const [fixedAssetform] = Form.useForm();
  const [itemsform] = Form.useForm();
  const [otherAssetform] = Form.useForm();
  const [liabilityForm] = Form.useForm();
  const [cashAndBankForm] = Form.useForm();
  const [capitalForm] = Form.useForm();
  // const { journalId } = useParams();
  const { currentClient, companySettings } = useClient();
  const { clientSpecificRole } = useUser();
  const { openNotification } = useContext(notificationContext);
  const [accounts, setAccounts] = useState<any[]>([]);
  const [listIndex, setListIndex] = useState<any>();
  const [loading, setLoading] = useState(false);
  const [isDisabled, setDisabled] = useState<boolean>(false);
  const [importedLedgers, setImportedLedgers] = useState<any>(null);
  const [journalId, setJournalId] = useState<string>("");
  const [addItemTrigger, setAddItemTrigger] = React.useState<boolean>(false);
  const [addAssetTrigger, setAddAssetTrigger] = React.useState<boolean>(false);
  const [trigger, setTrigger] = useState<boolean>(false);
  // const [importModal, setImportModal] = React.useState<any>({
  //   type: "",
  //   param: {},
  // });
  const [saveButtonLoading, setSaveButtonLoading] = useState<boolean>(false);
  //credit and debit total according to blocks
  const [debitTotalCreditor, setDebitTotalCreditor] = useState<number>(0);
  const [debitTotalDebitor, setDebitTotalDebitor] = useState<number>(0);
  const [debitTotalFixedAsset, setDebitTotalFixedAsset] = useState<number>(0);
  const [debitTotalItems, setDebitTotalItems] = useState<number>(0);
  const [debitTotalOtherAsset, setDebitTotalOtherAssets] = useState<number>(0);
  const [debitTotalLiability, setDebitTotalLiability] = useState<number>(0);
  const [debitTotalCashAndBank, setDebitTotalCashAndBank] = useState<number>(0);
  const [debitTotalCapital, setDebitTotalCapital] = useState<number>(0);

  const [creditTotalCreditor, setCreditTotalCreditor] = useState<number>(0);
  const [creditTotalDebitor, setCreditTotalDebitor] = useState<number>(0);
  const [creditTotalFixedAsset, setCreditTotalFixedAsset] = useState<number>(0);
  const [creditTotalItems, setCreditTotalItems] = useState<number>(0);
  const [creditTotalOtherAsset, setCreditTotalOtherAsset] = useState<number>(0);
  const [creditTotalLiability, setCreditTotalLiability] = useState<number>(0);
  const [creditTotalCashAndBank, setCreditTotalCashAndBank] =
    useState<number>(0);
  const [creditTotalCapital, setCreditTotalCapital] = useState<number>(0);

  // confirmation according to blocks
  const [confirmationCreditor, setConfirmationCreditor] =
    useState<boolean>(false);
  const [confirmationDebitor, setConfirmationDebitor] =
    useState<boolean>(false);
  const [confirmationFixedAsset, setConfirmationFixedAsset] =
    useState<boolean>(false);
  const [confirmationItems, setConfirmationItems] = useState<boolean>(false);
  const [confirmationOtherAsset, setConfirmationOtherAsset] =
    useState<boolean>(false);
  const [confirmationLiability, setConfirmationLiability] =
    useState<boolean>(false);
  const [confirmationCashAndBank, setConfirmationCashAndBank] =
    useState<boolean>(false);
  const [confirmationCapital, setConfirmationCapital] =
    useState<boolean>(false);

  //party ledger according to blocks
  const [partyLedgerOptionCreditor, setPartyLedgerOptionCreditor] = useState<
    any[]
  >([]);
  const [partyLedgerOptionDebitors, setPartyLedgerOptionDebitors] = useState<
    any[]
  >([]);
  const [partyLedgerOptionFixedAsset, setPartyLedgerOptionFixedAsset] =
    useState<any[]>([]);
  const [partyLedgerOptionItems, setPartyLedgerOptionItems] = useState<any[]>(
    []
  );

  const [partyLedgerOptionOtherAsset, setPartyLedgerOptionOtherAsset] =
    useState<any[]>([]);
  const [partyLedgerOptionLiability, setPartyLedgerOptionLiability] = useState<
    any[]
  >([]);
  const [partyLedgerOptionCashAndBank, setPartyLedgerOptionCashAndBank] =
    useState<any[]>([]);
  const [partyLedgerOptionCapital, setPartyLedgerOptionCapital] = useState<
    any[]
  >([]);

  //selected party according to blocks
  const [selectedPartyOptionCreditor, setSelectedPartyOptionCreditor] =
    React.useState<any[]>([]);
  const [selectedPartyOptionDebitors, setSelectedPartyOptionDebitors] =
    React.useState<any[]>([]);
  const [selectedPartyOptionFixedAsset, setSelectedPartyOptionFixedAsset] =
    React.useState<any[]>([]);
  const [selectedPartyOptionItems, setSelectedPartyOptionItems] =
    React.useState<any[]>([]);
  const [selectedPartyOptionOtherAsset, setSelectedPartyOptionOtherAsset] =
    React.useState<any[]>([]);
  const [selectedPartyOptionLiability, setSelectedPartyOptionLiability] =
    React.useState<any[]>([]);
  const [selectedPartyOptionCashAndBank, setSelectedPartyOptionCashAndBank] =
    React.useState<any[]>([]);
  const [selectedPartyOptionCapital, setSelectedPartyOptionCapital] =
    React.useState<any[]>([]);

  const [importedCustomersList, setImportedCustomersList] = React.useState<
    any[]
  >([]);
  const [importedSuppliersList, setImportedSuppliersList] = React.useState<
    any[]
  >([]);
  const [openModel, setOpenModel] = React.useState<{
    type: string;
    param: any;
  }>({
    type: "",
    param: "",
  });
  const [addLedgerResponse, setAddLedgerResponse] = useState<any>(null);

  const [
    fixedAssetListPassToOpeningBalance,
    setFixedAssetListPassToOpeningBalance,
  ] = useState<any[]>([]);
  const [itemsListPassToOpeningBalance, setItemsListPassToOpeningBalance] =
    useState<any[]>([]);
  //for import open in Customer , Supplier and Asset Other Than Fixed Asset
  const [openImportModalofCustomer, setOpenImportModalofCustomer] =
    React.useState<any>(false);
  const [openImportModalofSupplier, setOpenImportModalofSupplier] =
    React.useState<any>(false);
  const [openImportModalofOtherAsset, setOpenImportModalofOtherAsset] =
    React.useState<any>(false);
  //for asset drawer open
  const [openAssetModal, setOpenAssetModal] = React.useState<{
    open: boolean;
    param: string;
    openingAsset: boolean;
  }>({
    param: "",
    open: false,
    openingAsset: false,
  });
  const [openItemModal, setOpenItemModal] = React.useState<any>(false);
  const [isOpeningEntryImported, setIsOpeningEntryImported] =
    React.useState<boolean>(true);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const { TextArea } = Input;
  const showAssetModal = () => {
    setOpenAssetModal({ param: "", open: true, openingAsset: false });
  };

  const closeAssetModal = () => {
    setOpenAssetModal({ param: "", open: false, openingAsset: false });
  };
  const closeItemModal = () => {
    setOpenItemModal(false);
  };

  console.log(
    "fixedAssetListPassToOpeningBalance: ",
    fixedAssetListPassToOpeningBalance
  );

  const getSuppliers = async () => {
    await LedgerService.getLedgersByGroupName(
      currentClient?.id!,
      SearchLedgerByGroupsTypes?.CreditorsOnly
    ).then((res) => {
      if (res) {
        setPartyLedgerOptionCreditor(res);
      }
    });
  };
  const getCustomers = async () => {
    await LedgerService.getLedgersByGroupName(
      currentClient?.id!,
      SearchLedgerByGroupsTypes?.DebtorsOnly
    ).then((res) => {
      if (res) {
        setPartyLedgerOptionDebitors(res);
      }
    });
  };
  const getFixedAssets = async () => {
    await LedgerService.getLedgersByGroupName(
      currentClient?.id!,
      SearchLedgerByGroupsTypes?.FixedAssets
    ).then((res) => {
      if (res) {
        setPartyLedgerOptionFixedAsset(res);
      }
    });
  };
  const getOtherThanFixedAssets = async () => {
    await LedgerService.getLedgersByGroupName(
      currentClient?.id!,
      SearchLedgerByGroupsTypes?.AssetsOtherThanFixedAssets
    ).then((res) => {
      if (res) {
        setPartyLedgerOptionOtherAsset(res);
      }
    });
  };
  const getLiabilitiesOtherThanCapital = async () => {
    await LedgerService.getLedgersByGroupName(
      currentClient?.id!,
      SearchLedgerByGroupsTypes?.LiabilitiesOtherThanCapital
    ).then((res) => {
      if (res) {
        setPartyLedgerOptionLiability(res);
      }
    });
  };
  const getCashnBank = async () => {
    await LedgerService.getLedgersByGroupName(
      currentClient?.id!,
      SearchLedgerByGroupsTypes?.BankAndCash
    ).then((res) => {
      if (res) {
        setPartyLedgerOptionCashAndBank(res);
      }
    });
  };
  const getCapital = async () => {
    await LedgerService.getLedgersByGroupName(
      currentClient?.id!,
      SearchLedgerByGroupsTypes?.CapitalOnly
    ).then((res) => {
      if (res) {
        setPartyLedgerOptionCapital(res);
      }
    });
  };

  useEffect(() => {
    getFixedAssets();
  }, [addAssetTrigger]);
  // *****
  useEffect(() => {
    if (addLedgerResponse) {
      const exists = partyLedgerOptionCreditor.some(
        (option: any) => option?.id === addLedgerResponse.id
      );
      if (exists) {
        let partyLedger = [
          ...(creditorform.getFieldValue("partyLedgerCreditor") || []),
        ];
        partyLedger.pop();
        partyLedger.push({
          credit: "0.00",
          debit: "0.00",
          amount: 0,
          id: {
            label: addLedgerResponse?.ledgerName,
            value: addLedgerResponse.id,
            key: addLedgerResponse.id,
            title: addLedgerResponse.partyOrTax,
          },
        });
        partyLedger.push({
          credit: "0.00",
          debit: "0.00",
          amount: "0.00",
          id: {},
        });
        const index = partyLedger.findIndex(
          (ledgerArray) => ledgerArray?.id?.value === addLedgerResponse.id
        );
        creditorform.setFieldValue("partyLedgerCreditor", partyLedger);
        updateTotals(creditorform, "partyLedgerCreditor", "Suppliers");
        onClickSelectPartyLedger(addLedgerResponse.id, index, "Suppliers");
        setAddLedgerResponse(null);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [partyLedgerOptionCreditor]);

  useEffect(() => {
    if (addLedgerResponse) {
      const exists = partyLedgerOptionDebitors.some(
        (option: any) => option?.id === addLedgerResponse.id
      );
      if (exists) {
        let partyLedger = [
          ...(debitorForm.getFieldValue("partyLedgerDebitor") || []),
        ];
        partyLedger.pop();
        partyLedger.push({
          credit: "0.00",
          debit: "0.00",
          amount: 0,
          id: {
            label: addLedgerResponse?.ledgerName,
            value: addLedgerResponse.id,
            key: addLedgerResponse.id,
            title: addLedgerResponse.partyOrTax,
          },
        });
        partyLedger.push({
          credit: "0.00",
          debit: "0.00",
          amount: "0.00",
          id: {},
        });
        const index = partyLedger.findIndex(
          (ledgerArray) => ledgerArray?.id?.value === addLedgerResponse.id
        );
        debitorForm.setFieldValue("partyLedgerDebitor", partyLedger);
        updateTotals(debitorForm, "partyLedgerDebitor", "Customers");
        onClickSelectPartyLedger(addLedgerResponse.id, index, "Customers");
        setAddLedgerResponse(null);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [partyLedgerOptionDebitors]);
  console.log(
    "fixedAssetListPassToOpeningBalance",
    fixedAssetListPassToOpeningBalance
  );

  useEffect(() => {
    if (addLedgerResponse) {
      const exists = partyLedgerOptionFixedAsset.some(
        (option: any) => option?.id === addLedgerResponse.id
      );
      if (exists) {
        let partyLedger = [
          ...(fixedAssetform.getFieldValue("partyLedgerFixedAsset") || []),
        ];
        partyLedger.pop();
        partyLedger.push({
          credit: "0.00",
          debit: "0.00",
          amount: 0,
          id: {
            label: addLedgerResponse?.ledgerName,
            value: addLedgerResponse.id,
            key: addLedgerResponse.id,
            title: addLedgerResponse.partyOrTax,
          },
        });
        partyLedger.push({
          credit: "0.00",
          debit: "0.00",
          amount: "0.00",
          id: {},
        });
        const index = partyLedger.findIndex(
          (ledgerArray) => ledgerArray?.id?.value === addLedgerResponse.id
        );
        fixedAssetform.setFieldValue("partyLedgerFixedAsset", partyLedger);
        updateTotals(fixedAssetform, "partyLedgerFixedAsset", "FixedAssets");
        onClickSelectPartyLedger(addLedgerResponse.id, index, "FixedAssets");
        setAddLedgerResponse(null);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [partyLedgerOptionFixedAsset]);

  useEffect(() => {
    if (addLedgerResponse) {
      const exists = partyLedgerOptionOtherAsset.some(
        (option: any) => option?.id === addLedgerResponse.id
      );
      if (exists) {
        let partyLedger = [
          ...(otherAssetform.getFieldValue("partyLedgerOtherAsset") || []),
        ];
        partyLedger.pop();
        partyLedger.push({
          credit: "0.00",
          debit: "0.00",
          amount: 0,
          id: {
            label: addLedgerResponse?.ledgerName,
            value: addLedgerResponse.id,
            key: addLedgerResponse.id,
            title: addLedgerResponse.partyOrTax,
          },
        });
        partyLedger.push({
          credit: "0.00",
          debit: "0.00",
          amount: "0.00",
          id: {},
        });
        const index = partyLedger.findIndex(
          (ledgerArray) => ledgerArray?.id?.value === addLedgerResponse.id
        );
        otherAssetform.setFieldValue("partyLedgerOtherAsset", partyLedger);
        updateTotals(
          otherAssetform,
          "partyLedgerOtherAsset",
          "OtherThanFixedAssets"
        );
        onClickSelectPartyLedger(
          addLedgerResponse.id,
          index,
          "OtherThanFixedAssets"
        );
        setAddLedgerResponse(null);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [partyLedgerOptionOtherAsset]);

  useEffect(() => {
    if (addLedgerResponse) {
      const exists = partyLedgerOptionLiability.some(
        (option: any) => option?.id === addLedgerResponse.id
      );
      if (exists) {
        let partyLedger = [
          ...(liabilityForm.getFieldValue("partyLedgerLiability") || []),
        ];
        partyLedger.pop();
        partyLedger.push({
          credit: "0.00",
          debit: "0.00",
          amount: 0,
          id: {
            label: addLedgerResponse?.ledgerName,
            value: addLedgerResponse.id,
            key: addLedgerResponse.id,
            title: addLedgerResponse.partyOrTax,
          },
        });
        partyLedger.push({
          credit: "0.00",
          debit: "0.00",
          amount: "0.00",
          id: {},
        });
        const index = partyLedger.findIndex(
          (ledgerArray) => ledgerArray?.id?.value === addLedgerResponse.id
        );
        liabilityForm.setFieldValue("partyLedgerLiability", partyLedger);
        updateTotals(
          liabilityForm,
          "partyLedgerLiability",
          "LiabilityOtherThanCapital"
        );
        onClickSelectPartyLedger(
          addLedgerResponse.id,
          index,
          "LiabilityOtherThanCapital"
        );
        setAddLedgerResponse(null);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [partyLedgerOptionLiability]);

  useEffect(() => {
    if (addLedgerResponse) {
      const exists = partyLedgerOptionCashAndBank.some(
        (option: any) => option?.id === addLedgerResponse.id
      );
      if (exists) {
        let partyLedger = [
          ...(cashAndBankForm.getFieldValue("partyLedgerCashAndBank") || []),
        ];
        partyLedger.pop();
        partyLedger.push({
          credit: "0.00",
          debit: "0.00",
          amount: 0,
          id: {
            label: addLedgerResponse?.ledgerName,
            value: addLedgerResponse.id,
            key: addLedgerResponse.id,
            title: addLedgerResponse.partyOrTax,
          },
        });
        partyLedger.push({
          credit: "0.00",
          debit: "0.00",
          amount: "0.00",
          id: {},
        });
        const index = partyLedger.findIndex(
          (ledgerArray) => ledgerArray?.id?.value === addLedgerResponse.id
        );
        cashAndBankForm.setFieldValue("partyLedgerCashAndBank", partyLedger);
        updateTotals(cashAndBankForm, "partyLedgerCashAndBank", "CashnBank");
        onClickSelectPartyLedger(addLedgerResponse.id, index, "CashnBank");
        setAddLedgerResponse(null);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [partyLedgerOptionCashAndBank]);

  useEffect(() => {
    if (addLedgerResponse) {
      const exists = partyLedgerOptionCapital.some(
        (option: any) => option?.id === addLedgerResponse.id
      );
      if (exists) {
        let partyLedger = [
          ...(capitalForm.getFieldValue("partyLedgerCapital") || []),
        ];
        partyLedger.pop();
        partyLedger.push({
          credit: "0.00",
          debit: "0.00",
          amount: 0,
          id: {
            label: addLedgerResponse?.ledgerName,
            value: addLedgerResponse.id,
            key: addLedgerResponse.id,
            title: addLedgerResponse.partyOrTax,
          },
        });
        partyLedger.push({
          credit: "0.00",
          debit: "0.00",
          amount: "0.00",
          id: {},
        });
        const index = partyLedger.findIndex(
          (ledgerArray) => ledgerArray?.id?.value === addLedgerResponse.id
        );
        capitalForm.setFieldValue("partyLedgerCapital", partyLedger);
        updateTotals(capitalForm, "partyLedgerCapital", "Capital");
        onClickSelectPartyLedger(addLedgerResponse.id, index, "Capital");
        setAddLedgerResponse(null);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [partyLedgerOptionCapital]);

  const updateFormnStates = (
    arrayName: any,
    data: any,
    category: OpeningEntry_Categories
  ) => {
    switch (category) {
      case OpeningEntry_Categories.customer:
        arrayName.push(data);
        setSelectedPartyOptionDebitors((prevState) => {
          const updatedSelectedOptions = [...prevState];
          if (
            updatedSelectedOptions.some((cLed: any) => cLed !== data.id?.value)
          ) {
            updatedSelectedOptions.push(data.id?.value);
          }
          return updatedSelectedOptions;
        });
        break;
      case OpeningEntry_Categories.supplier:
        arrayName.push(data);
        setSelectedPartyOptionCreditor((prevState) => {
          const updatedSelectedOptions = [...prevState];
          if (
            updatedSelectedOptions.some((cLed: any) => cLed !== data.id?.value)
          ) {
            updatedSelectedOptions.push(data.id?.value);
          }
          return updatedSelectedOptions;
        });

        break;
      case OpeningEntry_Categories.fixedAssets:
        arrayName.push(data);
        setSelectedPartyOptionFixedAsset((prevState) => {
          const updatedSelectedOptions = [...prevState];
          if (
            updatedSelectedOptions.some((cLed: any) => cLed !== data.id?.value)
          ) {
            updatedSelectedOptions.push(data.id?.value);
          }
          return updatedSelectedOptions;
        });

        break;
      case OpeningEntry_Categories.stock:
        arrayName.push(data);
        setSelectedPartyOptionItems((prevState) => {
          const updatedSelectedOptions = [...prevState];
          if (
            updatedSelectedOptions.some((cLed: any) => cLed !== data.id?.value)
          ) {
            updatedSelectedOptions.push(data.id?.value);
          }
          return updatedSelectedOptions;
        });

        break;
      case OpeningEntry_Categories.otherThanFixedAssets:
        arrayName.push(data);
        setSelectedPartyOptionOtherAsset((prevState) => {
          const updatedSelectedOptions = [...prevState];
          if (
            updatedSelectedOptions.some((cLed: any) => cLed !== data.id?.value)
          ) {
            updatedSelectedOptions.push(data.id?.value);
          }
          return updatedSelectedOptions;
        });

        break;
      case OpeningEntry_Categories.liability:
        arrayName.push(data);
        setSelectedPartyOptionLiability((prevState) => {
          const updatedSelectedOptions = [...prevState];
          if (
            updatedSelectedOptions.some((cLed: any) => cLed !== data.id?.value)
          ) {
            updatedSelectedOptions.push(data.id?.value);
          }
          return updatedSelectedOptions;
        });

        break;
      case OpeningEntry_Categories.cashBank:
        arrayName.push(data);
        setSelectedPartyOptionCashAndBank((prevState) => {
          const updatedSelectedOptions = [...prevState];
          if (
            updatedSelectedOptions.some((cLed: any) => cLed !== data.id?.value)
          ) {
            updatedSelectedOptions.push(data.id?.value);
          }
          return updatedSelectedOptions;
        });

        break;
      case OpeningEntry_Categories.capital:
        arrayName.push(data);
        setSelectedPartyOptionCapital((prevState) => {
          const updatedSelectedOptions = [...prevState];
          if (
            updatedSelectedOptions.some((cLed: any) => cLed !== data.id?.value)
          ) {
            updatedSelectedOptions.push(data.id?.value);
          }
          return updatedSelectedOptions;
        });
        break;
    }
  };
  // opening balance get api according to blocks
  useEffect(() => {
    setLoading(true);
    Promise.all([
      getCustomers(),
      getSuppliers(),
      getFixedAssets(),
      getOtherThanFixedAssets(),
      getLiabilitiesOtherThanCapital(),
      getCashnBank(),
      getCapital(),
    ]).then(() => {
      getOpeningBalance(currentClient?.id!);
      setLoading(false);
    });
    const getOpeningBalance = async (cliendId: string) => {
      if (cliendId) {
        let selDate = dayjs(dateForm.getFieldValue("date")).toISOString();
        await VoucherServices.openingEntryGet(cliendId, selDate).then((res) => {
          if (res) {
            setJournalId(res?.result?.id);
            setIsOpeningEntryImported(res?.result?.isOpeningEntryImported);
            res?.result?.id && setDisabled(true);
            let suppliersData: any = [];
            let customersData: any = [];
            let fixedAssetsData: any = [];
            let itemsData: any = [];
            let otherThanFixedAssetsData: any = [];
            let liabilitiesData: any = [];
            let cashnBankData: any = [];
            let capitalData: any = [];

            res?.result?.date &&
              dateForm.setFieldValue("date", dayjs(res?.result?.date));
            res?.result?.effectiveLedger?.map((eLed: any) => {
              var eTmpData = {
                ...eLed,
                debit: eLed.isDebitNature ? Math.abs(eLed.amount) : 0,
                credit: eLed.isDebitNature ? 0 : Math.abs(eLed.amount),
                id: {
                  key: eLed.id,
                  value: eLed.id,
                  label: eLed.ledgerName,
                  title: eLed.partyOrTax,
                },
              };

              switch (eLed.openingEntryCategory) {
                case OpeningEntry_Categories.customer:
                  updateFormnStates(
                    customersData,
                    eTmpData,
                    eLed.openingEntryCategory
                  );
                  break;
                case OpeningEntry_Categories.supplier:
                  updateFormnStates(
                    suppliersData,
                    eTmpData,
                    eLed.openingEntryCategory
                  );
                  break;
                case OpeningEntry_Categories.fixedAssets:
                  updateFormnStates(
                    fixedAssetsData,
                    eTmpData,
                    eLed.openingEntryCategory
                  );
                  break;
                case OpeningEntry_Categories.stock:
                  updateFormnStates(
                    itemsData,
                    eTmpData,
                    eLed.openingEntryCategory
                  );
                  break;
                case OpeningEntry_Categories.otherThanFixedAssets:
                  updateFormnStates(
                    otherThanFixedAssetsData,
                    eTmpData,
                    eLed.openingEntryCategory
                  );
                  break;
                case OpeningEntry_Categories.liability:
                  updateFormnStates(
                    liabilitiesData,
                    eTmpData,
                    eLed.openingEntryCategory
                  );
                  break;
                case OpeningEntry_Categories.cashBank:
                  updateFormnStates(
                    cashnBankData,
                    eTmpData,
                    eLed.openingEntryCategory
                  );
                  break;
                case OpeningEntry_Categories.capital:
                  updateFormnStates(
                    capitalData,
                    eTmpData,
                    eLed.openingEntryCategory
                  );
                  break;
              }
            });
            res?.result?.partyLedger?.map((pLed: any) => {
              var pTmpData = {
                ...pLed,
                debit: pLed.isDebitNature ? Math.abs(pLed.amount) : 0,
                credit: pLed.isDebitNature ? 0 : Math.abs(pLed.amount),
                id: {
                  key: pLed.id,
                  value: pLed.id,
                  label: pLed.ledgerName,
                  title: pLed.partyOrTax,
                },
              };
              switch (pLed.openingEntryCategory) {
                case OpeningEntry_Categories.customer:
                  updateFormnStates(
                    customersData,
                    pTmpData,
                    pLed.openingEntryCategory
                  );
                  break;
                case OpeningEntry_Categories.supplier:
                  updateFormnStates(
                    suppliersData,
                    pTmpData,
                    pLed.openingEntryCategory
                  );
                  break;
                case OpeningEntry_Categories.fixedAssets:
                  updateFormnStates(
                    fixedAssetsData,
                    pTmpData,
                    pLed.openingEntryCategory
                  );
                  break;
                case OpeningEntry_Categories.stock:
                  updateFormnStates(
                    itemsData,
                    pTmpData,
                    pLed.openingEntryCategory
                  );
                  break;
                case OpeningEntry_Categories.otherThanFixedAssets:
                  updateFormnStates(
                    otherThanFixedAssetsData,
                    pTmpData,
                    pLed.openingEntryCategory
                  );
                  break;
                case OpeningEntry_Categories.liability:
                  updateFormnStates(
                    liabilitiesData,
                    pTmpData,
                    pLed.openingEntryCategory
                  );
                  break;
                case OpeningEntry_Categories.cashBank:
                  updateFormnStates(
                    cashnBankData,
                    pTmpData,
                    pLed.openingEntryCategory
                  );
                  break;
                case OpeningEntry_Categories.capital:
                  updateFormnStates(
                    capitalData,
                    pTmpData,
                    pLed.openingEntryCategory
                  );
                  break;
              }
            });
            if (customersData?.length > 0) {
              debitorForm.setFieldValue("partyLedgerDebitor", customersData);
              setDebitTotalDebitor(
                Math.abs(
                  customersData.reduce(
                    (acc: number, rec: any) => acc + rec.debit,
                    0
                  )
                )
              );
              setCreditTotalDebitor(
                Math.abs(
                  customersData.reduce(
                    (acc: number, rec: any) => acc + rec.credit,
                    0
                  )
                )
              );
            }
            if (suppliersData?.length > 0) {
              creditorform.setFieldValue("partyLedgerCreditor", suppliersData);
              setDebitTotalCreditor(
                Math.abs(
                  suppliersData.reduce(
                    (acc: number, rec: any) => acc + rec.debit,
                    0
                  )
                )
              );
              setCreditTotalCreditor(
                Math.abs(
                  suppliersData.reduce(
                    (acc: number, rec: any) => acc + rec.credit,
                    0
                  )
                )
              );
            }
            if (fixedAssetsData?.length > 0) {
              fixedAssetform.setFieldValue(
                "partyLedgerFixedAsset",
                fixedAssetsData
              );
              setDebitTotalFixedAsset(
                Math.abs(
                  fixedAssetsData.reduce(
                    (acc: number, rec: any) => acc + rec.debit,
                    0
                  )
                )
              );
              setCreditTotalFixedAsset(
                Math.abs(
                  fixedAssetsData.reduce(
                    (acc: number, rec: any) => acc + rec.credit,
                    0
                  )
                )
              );
            }
            if (itemsData?.length > 0) {
              itemsform.setFieldValue("partyLedgerItems", itemsData);
              setDebitTotalItems(
                Math.abs(
                  itemsData.reduce(
                    (acc: number, rec: any) => acc + rec.debit,
                    0
                  )
                )
              );
              setCreditTotalItems(
                Math.abs(
                  itemsData.reduce(
                    (acc: number, rec: any) => acc + rec.credit,
                    0
                  )
                )
              );
            }
            if (otherThanFixedAssetsData?.length > 0) {
              otherAssetform.setFieldValue(
                "partyLedgerOtherAsset",
                otherThanFixedAssetsData
              );
              setDebitTotalOtherAssets(
                Math.abs(
                  otherThanFixedAssetsData.reduce(
                    (acc: number, rec: any) => acc + rec.debit,
                    0
                  )
                )
              );
              setCreditTotalOtherAsset(
                Math.abs(
                  otherThanFixedAssetsData.reduce(
                    (acc: number, rec: any) => acc + rec.credit,
                    0
                  )
                )
              );
            }
            if (liabilitiesData?.length > 0) {
              liabilityForm.setFieldValue(
                "partyLedgerLiability",
                liabilitiesData
              );
              setDebitTotalLiability(
                Math.abs(
                  liabilitiesData.reduce(
                    (acc: number, rec: any) => acc + rec.debit,
                    0
                  )
                )
              );
              setCreditTotalLiability(
                Math.abs(
                  liabilitiesData.reduce(
                    (acc: number, rec: any) => acc + rec.credit,
                    0
                  )
                )
              );
            }
            if (cashnBankData?.length > 0) {
              cashAndBankForm.setFieldValue(
                "partyLedgerCashAndBank",
                cashnBankData
              );
              setDebitTotalCashAndBank(
                Math.abs(
                  cashnBankData.reduce(
                    (acc: number, rec: any) => acc + rec.debit,
                    0
                  )
                )
              );
              setCreditTotalCashAndBank(
                Math.abs(
                  cashnBankData.reduce(
                    (acc: number, rec: any) => acc + rec.credit,
                    0
                  )
                )
              );
            }
            if (capitalData?.length > 0) {
              capitalForm.setFieldValue("partyLedgerCapital", capitalData);
              setDebitTotalCapital(
                Math.abs(
                  capitalData?.reduce(
                    (acc: number, rec: any) => acc + rec.debit,
                    0
                  )
                )
              );
              setCreditTotalCapital(
                Math.abs(
                  capitalData?.reduce(
                    (acc: number, rec: any) => acc + rec.credit,
                    0
                  )
                )
              );
            }
          }
        });
      }
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentClient?.id]);

  // handle Total Change according to blocks
  const handleTotalChange = (List: any, category: string) => {
    let filterList = List.filter(
      (v: any) => v?.credit !== undefined || v?.debit !== undefined
    );

    const TotalCredit = filterList.reduce((acc: number, curr: any) => {
      return (acc += Utils.getNumber(curr?.credit));
    }, 0);
    switch (category) {
      case "Customers":
        setCreditTotalDebitor(TotalCredit);
        break;
      case "Suppliers":
        setCreditTotalCreditor(TotalCredit);
        break;
      case "FixedAssets":
        setCreditTotalFixedAsset(TotalCredit);
        break;
      case "Items":
        setCreditTotalItems(TotalCredit);
        break;
      case "OtherThanFixedAssets":
        setCreditTotalOtherAsset(TotalCredit);
        break;
      case "LiabilityOtherThanCapital":
        setCreditTotalLiability(TotalCredit);
        break;
      case "CashnBank":
        setCreditTotalCashAndBank(TotalCredit);
        break;
      case "Capital":
        setCreditTotalCapital(TotalCredit);
        break;
    }

    const TotalDebit = filterList.reduce((acc: number, curr: any) => {
      return (acc += Utils.getNumber(curr?.debit));
    }, 0);
    switch (category) {
      case "Customers":
        setDebitTotalDebitor(TotalDebit);
        break;
      case "Suppliers":
        setDebitTotalCreditor(TotalDebit);
        break;
      case "FixedAssets":
        setDebitTotalFixedAsset(TotalDebit);
        break;
      case "Items":
        setDebitTotalItems(TotalDebit);
        break;
      case "OtherThanFixedAssets":
        setDebitTotalOtherAssets(TotalDebit);
        break;
      case "LiabilityOtherThanCapital":
        setDebitTotalLiability(TotalDebit);
        break;
      case "CashnBank":
        setDebitTotalCashAndBank(TotalDebit);
        break;
      case "Capital":
        setDebitTotalCapital(TotalDebit);
        break;
    }
  };

  const onCreditBlur = (
    val: string,
    index: number,
    form: any,
    fieldname: string,
    category: string
  ) => {
    const itemList = form.getFieldValue([fieldname]);
    const updatedItems = [...itemList];
    if (val) {
      if (Utils.getNumber(val) !== 0) {
        updatedItems[index].debit = Utils.getFormattedNumber(0);
        updatedItems[index].credit = Utils.getFormattedNumber(val);
      } else updatedItems[index].credit = Utils.getFormattedNumber(val);
    } else updatedItems[index].credit = Utils.getFormattedNumber(0);
    form.setFieldValue(fieldname, updatedItems);
    handleTotalChange(updatedItems, category);
  };

  const onDebitBlur = (
    val: string,
    index: number,
    form: any,
    fieldname: string,
    category: string
  ) => {
    const itemList = form.getFieldValue([fieldname]);
    const updatedItems = [...itemList];
    if (val) {
      if (Utils.getNumber(val) !== 0) {
        updatedItems[index].credit = Utils.getFormattedNumber(0);
        updatedItems[index].debit = Utils.getFormattedNumber(val);
      } else updatedItems[index].debit = Utils.getFormattedNumber(val);
    } else updatedItems[index].debit = Utils.getFormattedNumber(0);
    form.setFieldValue(fieldname, updatedItems);
    handleTotalChange(updatedItems, category);
  };

  const debitRefs: any = useRef([]);
  const creditRefs: any = useRef([]);

  const updateTotals = (form: any, fieldname: string, category: string) => {
    // const updatedFields = form.getFieldValue(["partyLedger"]);
    const currentFields = form.getFieldValue([fieldname]) || [];
    const nonNullFields = currentFields.filter(
      (item: any) => item !== null && item !== undefined
    );

    const totalDebit = nonNullFields.reduce(
      (sum: number, item: any) => sum + Utils.getNumber(item.debit),
      0
    );

    const totalCredit = nonNullFields.reduce(
      (sum: number, item: any) => sum + Utils.getNumber(item.credit),
      0
    );
    const remainingDebit = totalCredit - totalDebit;
    const remainingCredit = totalDebit - totalCredit;
    const lastIndex = currentFields.length - 2;
    if (currentFields.length > 2) {
      if (remainingDebit > 0) {
        debitRefs.current[lastIndex].select();
        currentFields[lastIndex].debit = remainingDebit;
        currentFields[lastIndex].credit = "0.00";
      } else if (remainingCredit > 0) {
        creditRefs.current[lastIndex].select();
        currentFields[lastIndex].credit = remainingCredit;
        currentFields[lastIndex].debit = "0.00";
      } else {
        debitRefs.current[lastIndex].select();
        currentFields[lastIndex].debit = "0.00";
        currentFields[lastIndex].credit = "0.00";
      }
      // console.log("updatedFields", currentFields);
      form.setFieldsValue({ fieldname: currentFields });
      handleTotalChange(currentFields, category);
    } else {
      debitRefs.current[lastIndex].select();
    }
  };

  // post (save) add OpeningBalance api
  const AddOpeningBalance = () => {
    try {
      var givenDate: any;
      let ledgersData: any[] = [];
      let suppliersData: any[] = [];
      let customersData: any[] = [];
      let fixedAssetsData: any[] = [];
      let itemsData: any[] = [];
      let otherThanFixedAssetsData: any[] = [];
      let liabilitiesData: any[] = [];
      let cashnBankData: any[] = [];
      let capitalData: any[] = [];
      setLoading(true);
      setSaveButtonLoading(true);
      // if (dateForm.getFieldsValue()) {
      //   dateForm.validateFields();
      // }
      let tempVal: any;
      tempVal =
        creditorform
          ?.getFieldValue("partyLedgerCreditor")
          ?.filter((led: any) => led.id?.value || led.amount === 0) || [];
      suppliersData = tempVal?.map((led: any) => ({
        ...led,
        partyOrTax: partyLedgerOptionCreditor.find(
          (ledger) => ledger.id === led.id?.value
        )?.partyOrTax,
        openingEntryCategory: OpeningEntry_Categories.supplier,
      }));

      tempVal =
        debitorForm
          ?.getFieldValue("partyLedgerDebitor")
          ?.filter((led: any) => led.id?.value || led.amount === 0) || [];
      customersData = tempVal?.map((led: any) => ({
        ...led,
        partyOrTax: partyLedgerOptionDebitors.find(
          (ledger) => ledger.id === led.id?.value
        )?.partyOrTax,

        openingEntryCategory: OpeningEntry_Categories.customer,
      }));

      tempVal =
        fixedAssetform
          ?.getFieldValue("partyLedgerFixedAsset")
          ?.filter((led: any) => led.id?.value || led.amount === 0) || [];
      fixedAssetsData = tempVal?.map((led: any) => ({
        ...led,
        partyOrTax: partyLedgerOptionFixedAsset.find(
          (ledger) => ledger.id === led.id?.value
        )?.partyOrTax,
        openingEntryCategory: OpeningEntry_Categories.fixedAssets,
      }));
      tempVal =
        itemsform
          ?.getFieldValue("partyLedgerItems")
          ?.filter((led: any) => led.id?.value || led.amount === 0) || [];
      itemsData = tempVal?.map((led: any) => ({
        ...led,
        partyOrTax: partyLedgerOptionItems.find(
          (ledger) => ledger.id === led.id?.value
        )?.partyOrTax,
        openingEntryCategory: OpeningEntry_Categories.stock,
      }));

      tempVal =
        otherAssetform
          ?.getFieldValue("partyLedgerOtherAsset")
          ?.filter((led: any) => led.id?.value || led.amount === 0) || [];
      otherThanFixedAssetsData = tempVal?.map((led: any) => ({
        ...led,
        partyOrTax: partyLedgerOptionOtherAsset.find(
          (ledger) => ledger.id === led.id?.value
        )?.partyOrTax,
        openingEntryCategory: OpeningEntry_Categories.otherThanFixedAssets,
      }));
      tempVal =
        liabilityForm
          ?.getFieldValue("partyLedgerLiability")
          ?.filter((led: any) => led.id?.value || led.amount === 0) || [];
      liabilitiesData = tempVal?.map((led: any) => ({
        ...led,
        partyOrTax: partyLedgerOptionLiability.find(
          (ledger) => ledger.id === led.id?.value
        )?.partyOrTax,
        openingEntryCategory: OpeningEntry_Categories.liability,
      }));
      tempVal =
        cashAndBankForm
          ?.getFieldValue("partyLedgerCashAndBank")
          ?.filter((led: any) => led.id?.value || led.amount === 0) || [];
      cashnBankData = tempVal?.map((led: any) => ({
        ...led,
        partyOrTax: partyLedgerOptionCashAndBank.find(
          (ledger) => ledger.id === led.id?.value
        )?.partyOrTax,
        openingEntryCategory: OpeningEntry_Categories.cashBank,
      }));

      tempVal =
        capitalForm
          ?.getFieldValue("partyLedgerCapital")
          ?.filter((led: any) => led.id?.value || led.amount === 0) || [];
      capitalData = tempVal?.map((led: any) => ({
        ...led,
        partyOrTax: partyLedgerOptionCapital.find(
          (ledger) => ledger.id === led.id?.value
        )?.partyOrTax,
        openingEntryCategory: OpeningEntry_Categories.capital,
      }));

      ledgersData = [
        ...suppliersData,
        ...customersData,
        ...fixedAssetsData,
        ...itemsData,
        ...otherThanFixedAssetsData,
        ...liabilitiesData,
        ...cashnBankData,
        ...capitalData,
      ];
      const effectiveLedger: any[] = [];
      const partyLedger: any[] = [];

      ledgersData?.map((x: any) => {
        if (parseFloat(x?.debit) > 0) {
          // console.log("Ledger Values: ", x);

          effectiveLedger.push({
            ...x,
            amount: x?.debit,
            id: x?.id?.value,
            // partyOrTax: x?.id?.title,
            isDebitNature: true,
            openingEntryCategory: x?.openingEntryCategory,
          });
        } else {
          partyLedger.push({
            ...x,
            amount: x?.credit,
            id: x?.id?.value,
            // partyOrTax: x?.id?.title,
            isDebitNature: false,
            openingEntryCategory: x?.openingEntryCategory,
          });
        }
      });
      dateForm
        .validateFields()
        .then(async (val: any) => {
          givenDate = new Date(val.date);
          const currentTime = new Date();
          // Set the time part of givenDate to match currentTime
          givenDate?.setHours(
            currentTime.getHours(),
            currentTime.getMinutes(),
            currentTime.getSeconds(),
            currentTime.getMilliseconds()
          );
          let selVoucherSetting =
            companySettings!.setting?.vouchersSettings?.find(
              (vch) => vch.settingType === SettingsSections.Journal
            );
          const data = {
            amount: 0,
            date: dayjs(givenDate).toISOString(),
            // dueDate: dayjs(val?.date).toISOString(),
            isReconciled: false,
            partyLedger: partyLedger,
            effectiveLedger: effectiveLedger,
            mode: VoucherMode.Opening,
            isOpeningEntryImported: isOpeningEntryImported,
            voucherType: Voucher_Type.Journal,
            voucherTitle: {
              id: selVoucherSetting?.id,
              name: selVoucherSetting?.title,
            },
          };

          console.log("post data", data);

          await VoucherServices.postVoucher(
            currentClient?.id!,
            Voucher_Type.Journal,
            data,
            journalId
          )
            .then(async (res) => {
              if (res?.status) {
                console.log(
                  "itemsListPassToOpeningBalance: ",
                  itemsListPassToOpeningBalance
                );

                var voucherRef = {
                  id: res?.result?.id,
                  name: res?.result?.name,
                };
                var itemsList =
                  itemsListPassToOpeningBalance.map<IOpeningEntryItemsList>(
                    (itm: any) =>
                      itm?.trackingType === Item_Nature.Batch
                        ? {
                            item: {
                              id: itm?.id,
                              name: itm?.name,
                              batchItems: itm?.batchItems?.map((bat: any) => ({
                                id: bat?.id,
                                price: bat?.purchasePrice,
                                qty: bat?.openingQuantity,
                              })),
                            },
                            qty: 0,
                            price: 0,
                            trackingType: itm?.trackingType,
                          }
                        : itm?.trackingType === Item_Nature.Serial
                        ? {
                            item: {
                              id: itm?.id,
                              name: itm?.name,
                              serialItems: itm?.serialItems?.map(
                                (ser: any) => ({
                                  id: ser?.id,
                                  price: itm?.pPrice,
                                  qty: itm?.qty,
                                })
                              ),
                            },
                            qty: itm?.qty,
                            price: itm?.pPrice,
                            trackingType: itm?.trackingType,
                          }
                        : {
                            item: {
                              id: itm?.id,
                              name: itm?.name,
                            },
                            qty: itm?.openingStock?.quantity,
                            price: itm?.openingStock?.price,
                            trackingType: itm?.trackingType,
                          }
                  );
                await ItemsService.PostOpeningItemInventory(
                  currentClient?.id!,
                  itemsList,
                  voucherRef,
                  data.date
                )
                  .then((res) => {})
                  .catch((ex) => {
                    setDisabled(true);
                    openNotification("error", ex?.message);
                  });
                setDisabled(true);
                openNotification(
                  "success",
                  `Opening Balance ${
                    journalId ? "updated successfully." : "added successfully."
                  }`
                );
                // navigate(`/accounts/clients/${currentClient?.id}/journals`);
              } else if (res?.message) {
                openNotification("error", res?.message);
              }
            })
            .catch((ex) => openNotification("error", ex));
        })
        .catch((err: any) => {
          console.log("Date Error:", err);
        })
        .finally(() => {
          setSaveButtonLoading(false);
          setLoading(false);
        });
    } catch (error) {
      console.log("error", error);

      setSaveButtonLoading(false);
      setLoading(false);
    }
  };

  // ************

  // useEffect(() => {
  //   if (importedLedgers) {
  //     setLoading(true);

  //     const partyLedger = importedLedgers?.reduce((acc: any[], l: any) => {
  //       // Check if the ledgerId exists in partyLedgerOption
  //       const isPartyLedger = partyLedgerOptionCreditor?.some(
  //         (p: any) => p.id === l.ledgerId
  //       );
  //       if (isPartyLedger) {
  //         acc.push({
  //           debit: Utils.getFormattedNumber(l.debit),
  //           credit: Utils.getFormattedNumber(l.credit),
  //           id: {
  //             label: l.ledgerName,
  //             value: l.ledgerId,
  //             key: l.ledgerId,
  //             title: l.partyOrTax,
  //           },
  //         });
  //       }
  //       return acc;
  //     }, []);
  //     partyLedger.push({});
  //     // console.log("partyLedger", partyLedger);
  //     creditorform.setFieldValue("partyLedgerCreditor", partyLedger);
  //     handleTotalChange(partyLedger, "Suppliers");
  //     setLoading(false);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [partyLedgerOptionCreditor]);

  // useEffect(() => {
  //   if (importedLedgers) {
  //     setLoading(true);

  //     const partyLedger = importedLedgers?.reduce((acc: any[], l: any) => {
  //       // Check if the ledgerId exists in partyLedgerOption
  //       const isPartyLedger = partyLedgerOptionDebitors?.some(
  //         (p: any) => p.id === l.ledgerId
  //       );
  //       if (isPartyLedger) {
  //         acc.push({
  //           debit: Utils.getFormattedNumber(l.debit),
  //           credit: Utils.getFormattedNumber(l.credit),
  //           id: {
  //             label: l.ledgerName,
  //             value: l.ledgerId,
  //             key: l.ledgerId,
  //             title: l.partyOrTax,
  //           },
  //         });
  //       }
  //       return acc;
  //     }, []);
  //     partyLedger.push({});
  //     console.log("partyLedgerCustomer", partyLedger);
  //     debitorForm.setFieldValue("partyLedgerDebitor", partyLedger);
  //     handleTotalChange(partyLedger, "Customers");
  //     setLoading(false);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [partyLedgerOptionDebitors]);

  // useEffect(() => {
  //   if (importedLedgers) {
  //     setLoading(true);

  //     const partyLedger = importedLedgers?.reduce((acc: any[], l: any) => {
  //       // Check if the ledgerId exists in partyLedgerOption
  //       const isPartyLedger = partyLedgerOptionFixedAsset?.some(
  //         (p: any) => p.id === l.ledgerId
  //       );
  //       if (isPartyLedger) {
  //         acc.push({
  //           debit: Utils.getFormattedNumber(l.debit),
  //           credit: Utils.getFormattedNumber(l.credit),
  //           id: {
  //             label: l.ledgerName,
  //             value: l.ledgerId,
  //             key: l.ledgerId,
  //             title: l.partyOrTax,
  //           },
  //         });
  //       }
  //       return acc;
  //     }, []);
  //     partyLedger.push({});
  //     // console.log("partyLedger", partyLedger);
  //     fixedAssetform.setFieldValue("partyLedgerFixedAsset", partyLedger);
  //     handleTotalChange(partyLedger, "FixedAssets");
  //     setLoading(false);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [partyLedgerOptionFixedAsset]);

  // useEffect(() => {
  //   if (importedLedgers) {
  //     setLoading(true);

  //     const partyLedger = importedLedgers?.reduce((acc: any[], l: any) => {
  //       // Check if the ledgerId exists in partyLedgerOption
  //       const isPartyLedger = partyLedgerOptionOtherAsset?.some(
  //         (p: any) => p.id === l.ledgerId
  //       );
  //       if (isPartyLedger) {
  //         acc.push({
  //           debit: Utils.getFormattedNumber(l.debit),
  //           credit: Utils.getFormattedNumber(l.credit),
  //           id: {
  //             label: l.ledgerName,
  //             value: l.ledgerId,
  //             key: l.ledgerId,
  //             title: l.partyOrTax,
  //           },
  //         });
  //       }
  //       return acc;
  //     }, []);
  //     partyLedger.push({});
  //     // console.log("partyLedger", partyLedger);
  //     otherAssetform.setFieldValue("partyLedgerOtherAsset", partyLedger);
  //     handleTotalChange(partyLedger, "OtherThanFixedAssets");
  //     setLoading(false);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [partyLedgerOptionOtherAsset]);

  // useEffect(() => {
  //   if (importedLedgers) {
  //     setLoading(true);

  //     const partyLedger = importedLedgers?.reduce((acc: any[], l: any) => {
  //       // Check if the ledgerId exists in partyLedgerOption
  //       const isPartyLedger = partyLedgerOptionLiability?.some(
  //         (p: any) => p.id === l.ledgerId
  //       );
  //       if (isPartyLedger) {
  //         acc.push({
  //           debit: Utils.getFormattedNumber(l.debit),
  //           credit: Utils.getFormattedNumber(l.credit),
  //           id: {
  //             label: l.ledgerName,
  //             value: l.ledgerId,
  //             key: l.ledgerId,
  //             title: l.partyOrTax,
  //           },
  //         });
  //       }
  //       return acc;
  //     }, []);
  //     partyLedger.push({});
  //     // console.log("partyLedger", partyLedger);
  //     liabilityForm.setFieldValue("partyLedgerLiability", partyLedger);
  //     handleTotalChange(partyLedger, "LiabilityOtherThanCapital");
  //     setLoading(false);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [partyLedgerOptionLiability]);

  // useEffect(() => {
  //   if (importedLedgers) {
  //     setLoading(true);

  //     const partyLedger = importedLedgers?.reduce((acc: any[], l: any) => {
  //       // Check if the ledgerId exists in partyLedgerOption
  //       const isPartyLedger = partyLedgerOptionCashAndBank?.some(
  //         (p: any) => p.id === l.ledgerId
  //       );
  //       if (isPartyLedger) {
  //         acc.push({
  //           debit: Utils.getFormattedNumber(l.debit),
  //           credit: Utils.getFormattedNumber(l.credit),
  //           id: {
  //             label: l.ledgerName,
  //             value: l.ledgerId,
  //             key: l.ledgerId,
  //             title: l.partyOrTax,
  //           },
  //         });
  //       }
  //       return acc;
  //     }, []);
  //     partyLedger.push({});
  //     // console.log("partyLedger", partyLedger);
  //     cashAndBankForm.setFieldValue("partyLedgerCashAndBank", partyLedger);
  //     handleTotalChange(partyLedger, "CashnBank");
  //     setLoading(false);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [partyLedgerOptionCashAndBank]);

  // useEffect(() => {
  //   if (importedLedgers) {
  //     setLoading(true);

  //     const partyLedger = importedLedgers?.reduce((acc: any[], l: any) => {
  //       // Check if the ledgerId exists in partyLedgerOption
  //       const isPartyLedger = partyLedgerOptionCapital?.some(
  //         (p: any) => p.id === l.ledgerId
  //       );
  //       if (isPartyLedger) {
  //         acc.push({
  //           debit: Utils.getFormattedNumber(l.debit),
  //           credit: Utils.getFormattedNumber(l.credit),
  //           id: {
  //             label: l.ledgerName,
  //             value: l.ledgerId,
  //             key: l.ledgerId,
  //             title: l.partyOrTax,
  //           },
  //         });
  //       }
  //       return acc;
  //     }, []);
  //     partyLedger.push({});
  //     // console.log("partyLedger", partyLedger);
  //     capitalForm.setFieldValue("partyLedgerCapital", partyLedger);
  //     handleTotalChange(partyLedger, "Capital");
  //     setLoading(false);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [partyLedgerOptionCapital]);

  const focusOnvalue = (i: number, form: any, fieldname: string) => {
    const currentFields = [...form.getFieldValue(fieldname)];
    if (currentFields[i]?.debit > currentFields[i]?.credit) {
      debitRefs.current[i].select();
    } else if (currentFields[i]?.credit > currentFields[i]?.debit) {
      creditRefs.current[i].select();
    } else {
      debitRefs.current[i].select();
    }
  };

  const onClickSelectPartyLedger = (
    value: string,
    index: number,
    category: string
  ) => {
    // console.log("x", value, index);
    switch (category) {
      case "Suppliers":
        setSelectedPartyOptionCreditor((prevState) => {
          const updatedSelectedOptions = [...prevState];
          updatedSelectedOptions[index] = value;
          // console.log(updatedSelectedOptions);
          return updatedSelectedOptions;
        });
        break;
      case "Customers":
        setSelectedPartyOptionDebitors((prevState) => {
          const updatedSelectedOptions = [...prevState];
          updatedSelectedOptions[index] = value;
          // console.log(updatedSelectedOptions);
          return updatedSelectedOptions;
        });

        break;
      case "FixedAssets":
        setSelectedPartyOptionFixedAsset((prevState) => {
          const updatedSelectedOptions = [...prevState];
          updatedSelectedOptions[index] = value;
          // console.log(updatedSelectedOptions);
          return updatedSelectedOptions;
        });

        break;
      case "OtherThanFixedAssets":
        setSelectedPartyOptionOtherAsset((prevState) => {
          const updatedSelectedOptions = [...prevState];
          updatedSelectedOptions[index] = value;
          // console.log(updatedSelectedOptions);
          return updatedSelectedOptions;
        });

        break;
      case "LiabilityOtherThanCapital":
        setSelectedPartyOptionLiability((prevState) => {
          const updatedSelectedOptions = [...prevState];
          updatedSelectedOptions[index] = value;
          // console.log(updatedSelectedOptions);
          return updatedSelectedOptions;
        });

        break;
      case "CashnBank":
        setSelectedPartyOptionCashAndBank((prevState) => {
          const updatedSelectedOptions = [...prevState];
          updatedSelectedOptions[index] = value;
          // console.log(updatedSelectedOptions);
          return updatedSelectedOptions;
        });

        break;
      case "Capital":
        setSelectedPartyOptionCapital((prevState) => {
          const updatedSelectedOptions = [...prevState];
          updatedSelectedOptions[index] = value;
          // console.log(updatedSelectedOptions);
          return updatedSelectedOptions;
        });

        break;
    }
  };

  const importModelCustomer = () => (
    <>
      <Row style={{ gap: "50px", alignItems: "center" }} className="textEnd">
        <Row style={{ gap: "5px" }}>
          <Col>Debit : </Col>
          <Col className="fw-600">
            {" "}
            ₹ {Utils.getFormattedNumber(debitTotalDebitor)}
          </Col>
        </Row>
        <Row style={{ gap: "5px" }}>
          <Col>Credit : </Col>
          <Col className="fw-600">
            {" "}
            ₹ {Utils.getFormattedNumber(creditTotalDebitor)}
          </Col>
        </Row>

        <Col>
          <Button
            style={{ border: "none" }}
            icon={<UploadOutlined />}
            onClick={() => {
              setOpenImportModalofCustomer("ImportCustomerModal");
            }}
          >
            {/* Import */}
          </Button>
        </Col>
      </Row>

      {openImportModalofCustomer === "ImportCustomerModal" && (
        <ImportPartyModal
          selType="Customer"
          onCancel={() => {
            setOpenImportModalofCustomer("");
          }}
          setImportedPartyList={setImportedCustomersList}
          // setImportedData = {}
        />
      )}
    </>
  );

  const importModelSupplier = () => (
    <>
      <Row style={{ gap: "50px", alignItems: "center" }} className="textEnd">
        <Row style={{ gap: "5px" }}>
          <Col> Debit : </Col>
          <Col className="fw-600">
            {" "}
            ₹ {Utils.getFormattedNumber(debitTotalCreditor)}
          </Col>
        </Row>
        <Row style={{ gap: "5px" }}>
          <Col> Credit : </Col>
          <Col className="fw-600">
            {" "}
            ₹ {Utils.getFormattedNumber(creditTotalCreditor)}
          </Col>
        </Row>

        <Col>
          <Button
            style={{ border: "none" }}
            icon={<UploadOutlined />}
            onClick={() => {
              setOpenImportModalofSupplier("ImportSupplierModal");
            }}
          >
            {/* Import */}
          </Button>
        </Col>
      </Row>
      {openImportModalofSupplier === "ImportSupplierModal" && (
        <ImportPartyModal
          selType="Supplier"
          onCancel={() => {
            setOpenImportModalofSupplier("");
          }}
          setImportedPartyList={setImportedSuppliersList}
        />
      )}
    </>
  );

  const importModelOtherAsset = () => (
    <>
      <Row style={{ gap: "50px", alignItems: "center" }} className="textEnd">
        <Row style={{ gap: "5px" }}>
          <Col> Debit : </Col>
          <Col className="fw-600">
            {" "}
            ₹ {Utils.getFormattedNumber(debitTotalOtherAsset)}
          </Col>
        </Row>
        <Row style={{ gap: "5px" }}>
          <Col> Credit : </Col>
          <Col className="fw-600">
            {" "}
            ₹ {Utils.getFormattedNumber(creditTotalOtherAsset)}
          </Col>
        </Row>
        <Col style={{ paddingRight: "30px" }}></Col>

        {/* <Col>
          <Button
            style={{ border: "none" }}
            icon={<UploadOutlined />}
            onClick={() => {
              setOpenImportModalofOtherAsset("ImportPartyModal");
            }}
          >
          </Button>
        </Col> */}
      </Row>
      {/* {openImportModalofOtherAsset === "ImportPartyModal" && (
        <ImportPartyModal
          selType=""
          onCancel={() => {
            setOpenImportModalofOtherAsset("");
          }}
        />
      )} */}
    </>
  );

  const handlePassFixedAssetsToForm = () => {
    if (!fixedAssetListPassToOpeningBalance?.length) return;
    let currentValues =
      fixedAssetform
        .getFieldValue("partyLedgerFixedAsset")
        .filter((item: { id: { value: string } }) => item.id?.value) || [];

    // console.log("Current Values:", currentValues);

    fixedAssetListPassToOpeningBalance.map((asset) => {
      const index = currentValues.findIndex(
        (item: { id: { value: any } }) => item.id?.value === asset.assetLedger
      );

      if (index !== -1) {
        currentValues[index].debit = asset.price;
      } else {
        currentValues.push({
          debit: asset.price * asset.qty,
          credit: "0.00",
          id: {
            value: asset.assetLedger,
            label: asset.assetRef?.name,
            key: asset.assetLedger,
          },
        });
        setSelectedPartyOptionFixedAsset((prev) => [
          ...prev,
          ...fixedAssetListPassToOpeningBalance.map((item) => item.assetLedger),
        ]);
      }
      // for Accumulated Depreciation ledger
      if (asset.isDepreciable) {
        const accuDepLedIndex = currentValues.findIndex(
          (item: { id: { value: any } }) =>
            item.id?.value === asset.accuDepreciationLedger
        );
        let ledgerDetail = partyLedgerOptionFixedAsset.find(
          (led: any) => led.id == asset.accuDepreciationLedger
        );
        if (accuDepLedIndex !== -1) {
          currentValues[accuDepLedIndex].credit = asset.accumulatedDepreciation;
        } else {
          currentValues.push({
            debit: "0.00",
            credit: asset.accumulatedDepreciation * asset.qty,
            id: {
              value: asset.accuDepreciationLedger,
              label: ledgerDetail?.ledgerName,
              key: asset.accuDepreciationLedger,
            },
          });
          setSelectedPartyOptionFixedAsset((prev) => [
            ...prev,
            ...fixedAssetListPassToOpeningBalance.map(
              (item) => item.accuDepreciationLedger
            ),
          ]);
        }
      }
    });

    currentValues.push({
      debit: "0.00",
      credit: "0.00",
    });

    fixedAssetform.setFieldValue("partyLedgerFixedAsset", currentValues);

    handleTotalChange(currentValues, "FixedAssets");

    setIsButtonDisabled(true);
  };
  console.log("itemsListPassToOpeningBalance: ", itemsListPassToOpeningBalance);

  const handlePassItemsToForm = () => {
    if (!itemsListPassToOpeningBalance?.length) return;
    var openingStockLedger: any = partyLedgerOptionOtherAsset?.find(
      (led: any) => led.ledgerName === "Opening Stock"
    );
    let currentValues = [
      {
        debit: itemsListPassToOpeningBalance?.reduce(
          (acc: number, rcc: any) =>
            acc +
            (rcc.trackingType === Item_Nature.Normal
              ? rcc.openingStock?.totalAmount
              : rcc.trackingType === Item_Nature.Batch
              ? rcc.batchItem?.reduce(
                  (accbat: number, rccbat: any) => accbat + rccbat.totalAmount,
                  0
                )
              : rcc.serialItem?.reduce(
                  (accser: number, rccser: any) => accser + rccser.totalAmount,
                  0
                )),
          0
        ),
        credit: "0.00",
        id: {
          value: openingStockLedger?.id,
          label: openingStockLedger?.ledgerName,
          key: openingStockLedger?.id,
        },
      },
    ];

    itemsform.setFieldValue("partyLedgerItems", currentValues);

    handleTotalChange(currentValues, "Items");

    setIsButtonDisabled(true);
  };

  useEffect(() => {
    passImportCustomersListToForm();
  }, [importedCustomersList]);

  const passImportCustomersListToForm = () => {
    if (!importedCustomersList?.length) return;
    getCustomers();
    let currentValues =
      debitorForm
        ?.getFieldValue("partyLedgerDebitor")
        .filter((item: { id: { value: any } }) => item.id?.value) || [];

    importedCustomersList?.map((led: any) => {
      const index = currentValues.findIndex(
        (item: { id: { value: any } }) => item.id?.value === led.id
      );

      if (index === -1) {
        currentValues.push({
          debit: "0.00",
          credit: "0.00",
          id: {
            value: led.id,
            label: led.name,
            key: led.id,
          },
        });
        setSelectedPartyOptionDebitors((prev) => [...prev, led.id]);
      }
    });

    currentValues.push({
      debit: "0.00",
      credit: "0.00",
    });

    debitorForm.setFieldValue("partyLedgerDebitor", currentValues);

    handleTotalChange(currentValues, "Customers");

    setIsButtonDisabled(true);
  };

  useEffect(() => {
    passImportSuppliersListToForm();
  }, [importedSuppliersList]);

  const passImportSuppliersListToForm = () => {
    if (!importedSuppliersList?.length) return;
    getSuppliers();
    let currentValues =
      creditorform
        ?.getFieldValue("partyLedgerCreditor")
        .filter((item: { id: { value: any } }) => item.id?.value) || [];

    importedSuppliersList?.map((led: any) => {
      const index = currentValues.findIndex(
        (item: { id: { value: any } }) => item.id?.value === led.id
      );

      if (index === -1) {
        currentValues.push({
          debit: "0.00",
          credit: "0.00",
          id: {
            value: led.id,
            label: led.name,
            key: led.id,
          },
        });
        setSelectedPartyOptionCreditor((prev) => [...prev, led.id]);
      }
    });

    currentValues.push({
      debit: "0.00",
      credit: "0.00",
    });

    creditorform.setFieldValue("partyLedgerCreditor", currentValues);

    handleTotalChange(currentValues, "Suppliers");

    setIsButtonDisabled(true);
  };
  // console.log("Selected Customer List:", selectedPartyOptionDebitors);

  const permissionCustomerAdd = findUserOnlyOnePremission(
    "Master.Ledger.Customer.Add",
    clientSpecificRole(),
    currentClient?.id
  );

  const permissionSuppliersAdd = findUserOnlyOnePremission(
    "Master.Ledger.Suppliers.Add",
    clientSpecificRole(),
    currentClient?.id
  );

  const permissionFixedAssetAdd = findUserPremission(
    ["Voucher.Asset.11.Add"],
    clientSpecificRole(),
    currentClient?.id!,
    [SettingsSections.Asset],
    {
      actionType: IPermissionActionType.Add,
      dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
    }
  );

  const permissionLedgerAdd = findUserOnlyOnePremission(
    "Master.Ledger.Add",
    clientSpecificRole(),
    currentClient?.id!
  );

  const permissionItemAdd = findUserOnlyOnePremission(
    "Master.Item.Add",
    clientSpecificRole(),
    currentClient?.id
  );

  const permissionCashAdd = findUserOnlyOnePremission(
    "Master.Ledger.Cash.Add",
    clientSpecificRole(),
    currentClient?.id
  );

  const permissionBankAdd = findUserOnlyOnePremission(
    "Master.Ledger.Bank.Add",
    clientSpecificRole(),
    currentClient?.id
  );

  const items: CollapseProps["items"] = [
    {
      key: "customer",
      label: "Customer",
      children: (
        <div style={{ padding: "0px 0px 3px 0px", width: "60%" }}>
          <Form
            form={debitorForm}
            autoComplete="off"
            name="openingBalanceForDebitor"
            disabled={isDisabled}
            initialValues={{
              partyLedgerDebitor: [{}],
            }}
          >
            <div>
              <table className="AddPageTabelDesign">
                <thead>
                  <tr>
                    <th style={{ width: "60%" }}>Account</th>
                    <th style={{ width: "20%" }}>Debit</th>
                    <th colSpan={2} style={{ width: "20%" }}>
                      Credit
                    </th>
                  </tr>
                </thead>
                <Form.List name="partyLedgerDebitor">
                  {(fields, { add, remove }) => {
                    return (
                      <>
                        <tbody>
                          {fields.map(
                            (
                              { key, name, ...restField }: any,
                              index: number
                            ) => {
                              return (
                                <tr key={key}>
                                  <td>
                                    <Form.Item
                                      name={[name, "id"]}
                                      className="m-0"
                                      {...restField}
                                    >
                                      <Select
                                        labelInValue
                                        showSearch
                                        placeholder="Search to customer"
                                        optionFilterProp="children"
                                        popupMatchSelectWidth={false}
                                        style={{ width: "100%" }}
                                        dropdownStyle={{
                                          width: "250px",
                                        }}
                                        placement="bottomRight"
                                        // onSearch={(value: string) =>
                                        //   setSearchItem(value)
                                        // }
                                        options={partyLedgerOptionDebitors
                                          .filter(
                                            (option) =>
                                              !selectedPartyOptionDebitors.includes(
                                                option.id
                                              )
                                          )
                                          .map((option: any) => ({
                                            value: option?.id,
                                            label: option?.ledgerName,
                                            title: option?.partyOrTax,
                                          }))}
                                        filterOption={(input, option) =>
                                          (option?.label?.toString() ?? "")
                                            .toLowerCase()
                                            .includes(input.toLowerCase())
                                        }
                                        onChange={(e: any) => {
                                          if (fields.length === index + 1) {
                                            add();
                                            updateTotals(
                                              debitorForm,
                                              "partyLedgerDebitor",
                                              "Customers"
                                            );
                                          } else {
                                            focusOnvalue(
                                              index,
                                              debitorForm,
                                              "partyLedgerDebitor"
                                            );
                                          }
                                          //   partySelect(e.value, index, e.title);
                                          onClickSelectPartyLedger(
                                            e.value,
                                            index,
                                            "Customers"
                                          );
                                        }}
                                        dropdownRender={(customerOptions) => (
                                          <>
                                            {customerOptions}
                                            {permissionCustomerAdd && (
                                              <>
                                                <Divider
                                                  style={{
                                                    margin: "5px 0px",
                                                  }}
                                                />
                                                <Button
                                                  style={{ width: "100%" }}
                                                  icon={<PlusOutlined />}
                                                  type="link"
                                                  onClick={() => {
                                                    setOpenModel({
                                                      type: "addCustomer",
                                                      param: {
                                                        open: true,
                                                      },
                                                    });
                                                    // setEditParty({ id: "" });
                                                  }}
                                                >
                                                  New Customer
                                                </Button>
                                              </>
                                            )}
                                          </>
                                        )}
                                      />
                                    </Form.Item>
                                  </td>
                                  <td>
                                    <Form.Item
                                      name={[name, "debit"]}
                                      {...restField}
                                      className="m-0"
                                      initialValue={Utils.getFormattedNumber(0)}
                                    >
                                      <Input
                                        ref={(el) =>
                                          (debitRefs.current[index] = el)
                                        }
                                        disabled={
                                          isDisabled ||
                                          fields.length === index + 1
                                        }
                                        className="textEnd"
                                        onBlur={(e) =>
                                          Number(e.target.value) > 0 &&
                                          onDebitBlur(
                                            e.target.value,
                                            index,
                                            debitorForm,
                                            "partyLedgerDebitor",
                                            "Customers"
                                          )
                                        }
                                        onChange={() =>
                                          handleTotalChange(
                                            debitorForm.getFieldValue([
                                              "partyLedgerDebitor",
                                            ]),
                                            "Customers"
                                          )
                                        }
                                      />
                                    </Form.Item>
                                  </td>
                                  <td style={{ width: "100%" }}>
                                    <Form.Item
                                      name={[name, "credit"]}
                                      {...restField}
                                      className="m-0"
                                      initialValue={Utils.getFormattedNumber(0)}
                                    >
                                      <Input
                                        ref={(el) =>
                                          (creditRefs.current[index] = el)
                                        }
                                        disabled={
                                          isDisabled ||
                                          fields.length === index + 1
                                        }
                                        className="textEnd"
                                        style={{}}
                                        onBlur={(e) =>
                                          Number(e.target.value) > 0 &&
                                          onCreditBlur(
                                            e.target.value,
                                            index,
                                            debitorForm,
                                            "partyLedgerDebitor",
                                            "Customers"
                                          )
                                        }
                                        onChange={() =>
                                          handleTotalChange(
                                            debitorForm.getFieldValue([
                                              "partyLedgerDebitor",
                                            ]),
                                            "Customers"
                                          )
                                        }
                                      />
                                    </Form.Item>
                                  </td>
                                  <td style={{ width: 30 }}>
                                    {fields.length !== index + 1 && (
                                      <img
                                        alt="Delete"
                                        src={deleteImg}
                                        className="cursor mx-1"
                                        style={{
                                          backgroundColor: isDisabled
                                            ? "#f2f2f2"
                                            : "",
                                        }}
                                        onClick={() => {
                                          !isDisabled && setListIndex(name);
                                          !isDisabled &&
                                            setConfirmationDebitor(true);
                                        }}
                                      />
                                    )}
                                  </td>
                                </tr>
                              );
                            }
                          )}
                        </tbody>
                        {confirmationDebitor && (
                          <ConfirmationModal
                            open={confirmationDebitor}
                            text="Do you really want to delete this row ?"
                            onNo={() => setConfirmationDebitor(false)}
                            onYes={() => {
                              const data = [
                                ...debitorForm.getFieldValue(
                                  "partyLedgerDebitor"
                                ),
                              ];
                              const rowsAccount =
                                debitorForm.getFieldValue("partyLedgerDebitor")[
                                  listIndex
                                ].account;
                              data.splice(listIndex, 1);
                              if (rowsAccount) {
                                setAccounts(
                                  accounts.map((group: ISelectGroup) => {
                                    return {
                                      ...group,
                                      options: group.options.map((o: any) => {
                                        if (o.key === rowsAccount?.key) {
                                          return {
                                            ...o,
                                            disabled: false,
                                          };
                                        }
                                        return o;
                                      }),
                                    };
                                  })
                                );
                              }
                              remove(listIndex);
                              handleTotalChange(data, "Customers");
                              setConfirmationDebitor(false);
                              setSelectedPartyOptionDebitors((prev) => {
                                const newDisabledInputs = [...prev];
                                newDisabledInputs.splice(listIndex, 1);
                                return newDisabledInputs;
                              });
                            }}
                          />
                        )}
                      </>
                    );
                  }}
                </Form.List>
              </table>
            </div>
          </Form>
          <Row className=" pt-10 mt-14">
            <Col lg={12}></Col>
            <Col lg={12}>
              <Row>
                <Col lg={4}>Total</Col>
                <Col lg={10} className="textEnd">
                  <span style={{ paddingRight: "12px" }}>
                    ₹ {Utils.getFormattedNumber(debitTotalDebitor)}
                  </span>
                </Col>
                <Col lg={10} className="textEnd">
                  <span style={{ paddingRight: "12px" }}>
                    ₹ {Utils.getFormattedNumber(creditTotalDebitor)}
                  </span>
                </Col>
              </Row>
              <Divider className="my-5 grayBg" />
            </Col>
          </Row>

          {/* {importModal?.type === "importModal" && (
            <ImportLedger
              onDismiss={(confirmed: boolean) => {
                setImportModal({ type: "", param: {} });
              }}
              setImportedLedgers={setImportedLedgers}
              setTrigger={setTrigger}
            />
          )} */}
          {openModel.type === "addCustomer" && (
            <AddLedger
              openDrawer={true}
              id={""}
              setOpenDrawer={() => setOpenModel({ type: "", param: "" })}
              setTrigger={() => setTrigger(!trigger)}
              setAddLedgerResponse={setAddLedgerResponse}
              type={SearchLedgerByGroupsTypes.DebtorsOnly}
              showName="Customer"
            />
          )}
        </div>
      ),
      extra: importModelCustomer(),
    },
    {
      key: "supplier",
      label: "Supplier",
      children: (
        <div style={{ padding: "0px 0px 3px 0px", width: "60%" }}>
          <Form
            form={creditorform}
            autoComplete="off"
            name="openingBalanceForCreditor"
            disabled={isDisabled}
            initialValues={{
              partyLedgerCreditor: [{}],
            }}
          >
            <div>
              <table className="AddPageTabelDesign">
                <thead>
                  <tr>
                    <th style={{ width: "60%" }}>Account</th>
                    <th style={{ width: "20%" }}>Debit</th>
                    <th colSpan={2} style={{ width: "20%" }}>
                      Credit
                    </th>
                  </tr>
                </thead>
                <Form.List name="partyLedgerCreditor">
                  {(fields, { add, remove }) => {
                    return (
                      <>
                        <tbody>
                          {fields.map(({ key, name, ...restField }, index) => {
                            return (
                              <tr key={key}>
                                <td>
                                  <Form.Item
                                    name={[name, "id"]}
                                    className="m-0"
                                    {...restField}
                                  >
                                    <Select
                                      labelInValue
                                      showSearch
                                      placeholder="Search to supplier"
                                      optionFilterProp="children"
                                      popupMatchSelectWidth={false}
                                      style={{ width: "100%" }}
                                      dropdownStyle={{
                                        width: "250px",
                                      }}
                                      placement="bottomRight"
                                      // onSearch={(value: string) =>
                                      //   setSearchItem(value)
                                      // }
                                      options={partyLedgerOptionCreditor
                                        .filter(
                                          (option) =>
                                            !selectedPartyOptionCreditor.includes(
                                              option.id
                                            )
                                        )
                                        .map((option: any) => ({
                                          value: option?.id,
                                          label: option?.ledgerName,
                                          title: option?.partyOrTax,
                                        }))}
                                      filterOption={(input, option) =>
                                        (option?.label?.toString() ?? "")
                                          .toLowerCase()
                                          .includes(input.toLowerCase())
                                      }
                                      onChange={(e: any) => {
                                        if (fields.length === index + 1) {
                                          add();
                                          updateTotals(
                                            creditorform,
                                            "partyLedgerCreditor",
                                            "Suppliers"
                                          );
                                        } else {
                                          focusOnvalue(
                                            index,
                                            creditorform,
                                            "partyLedgerCreditor"
                                          );
                                        }
                                        //   partySelect(e.value, index, e.title);
                                        onClickSelectPartyLedger(
                                          e.value,
                                          index,
                                          "Suppliers"
                                        );
                                      }}
                                      dropdownRender={(customerOptions) => (
                                        <>
                                          {customerOptions}
                                          {permissionSuppliersAdd && (
                                            <>
                                              <Divider
                                                style={{
                                                  margin: "5px 0px",
                                                }}
                                              />
                                              <Button
                                                style={{ width: "100%" }}
                                                icon={<PlusOutlined />}
                                                type="link"
                                                onClick={() => {
                                                  setOpenModel({
                                                    type: "addSupplier",
                                                    param: {
                                                      open: true,
                                                    },
                                                  });
                                                  // setEditParty({ id: "" });
                                                }}
                                              >
                                                New Supplier
                                              </Button>
                                            </>
                                          )}
                                        </>
                                      )}
                                    />
                                  </Form.Item>
                                </td>
                                <td>
                                  <Form.Item
                                    name={[name, "debit"]}
                                    {...restField}
                                    className="m-0"
                                    initialValue={Utils.getFormattedNumber(0)}
                                  >
                                    <Input
                                      ref={(el) =>
                                        (debitRefs.current[index] = el)
                                      }
                                      className="textEnd"
                                      disabled={
                                        isDisabled ||
                                        fields.length === index + 1
                                      }
                                      onBlur={(e) =>
                                        Number(e.target.value) > 0 &&
                                        onDebitBlur(
                                          e.target.value,
                                          index,
                                          creditorform,
                                          "partyLedgerCreditor",
                                          "Suppliers"
                                        )
                                      }
                                      onChange={() =>
                                        handleTotalChange(
                                          creditorform.getFieldValue([
                                            "partyLedgerCreditor",
                                          ]),
                                          "Suppliers"
                                        )
                                      }
                                    />
                                  </Form.Item>
                                </td>
                                <td style={{ width: "100%" }}>
                                  <Form.Item
                                    name={[name, "credit"]}
                                    {...restField}
                                    className="m-0"
                                    initialValue={Utils.getFormattedNumber(0)}
                                  >
                                    <Input
                                      ref={(el) =>
                                        (creditRefs.current[index] = el)
                                      }
                                      disabled={
                                        isDisabled ||
                                        fields.length === index + 1
                                      }
                                      className="textEnd"
                                      style={{}}
                                      onBlur={(e) =>
                                        Number(e.target.value) > 0 &&
                                        onCreditBlur(
                                          e.target.value,
                                          index,
                                          creditorform,
                                          "partyLedgerCreditor",
                                          "Suppliers"
                                        )
                                      }
                                      onChange={() =>
                                        handleTotalChange(
                                          creditorform.getFieldValue([
                                            "partyLedgerCreditor",
                                          ]),
                                          "Suppliers"
                                        )
                                      }
                                    />
                                  </Form.Item>
                                </td>
                                <td style={{ width: 30 }}>
                                  {fields.length !== index + 1 && (
                                    <img
                                      alt="Delete"
                                      src={deleteImg}
                                      className="cursor mx-1"
                                      style={{
                                        backgroundColor: isDisabled
                                          ? "#f2f2f2"
                                          : "",
                                      }}
                                      onClick={() => {
                                        !isDisabled && setListIndex(name);
                                        !isDisabled &&
                                          setConfirmationCreditor(true);
                                      }}
                                    />
                                  )}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                        {confirmationCreditor && (
                          <ConfirmationModal
                            open={confirmationCreditor}
                            text="Do you really want to delete this row ?"
                            onNo={() => setConfirmationCreditor(false)}
                            onYes={() => {
                              const data = [
                                ...creditorform.getFieldValue(
                                  "partyLedgerCreditor"
                                ),
                              ];
                              const rowsAccount = creditorform.getFieldValue(
                                "partyLedgerCreditor"
                              )[listIndex].account;
                              data.splice(listIndex, 1);
                              if (rowsAccount) {
                                setAccounts(
                                  accounts.map((group: ISelectGroup) => {
                                    return {
                                      ...group,
                                      options: group.options.map((o: any) => {
                                        if (o.key === rowsAccount?.key) {
                                          return {
                                            ...o,
                                            disabled: false,
                                          };
                                        }
                                        return o;
                                      }),
                                    };
                                  })
                                );
                              }
                              remove(listIndex);
                              handleTotalChange(data, "Suppliers");
                              setConfirmationCreditor(false);
                              setSelectedPartyOptionCreditor((prev) => {
                                const newDisabledInputs = [...prev];
                                newDisabledInputs.splice(listIndex, 1);
                                return newDisabledInputs;
                              });
                            }}
                          />
                        )}
                      </>
                    );
                  }}
                </Form.List>
              </table>
            </div>
          </Form>
          <Row className=" pt-10 mt-14">
            <Col lg={12}></Col>
            <Col lg={12}>
              <Row>
                <Col lg={4}>Total</Col>
                <Col lg={10} className="textEnd">
                  <span style={{ paddingRight: "12px" }}>
                    ₹ {Utils.getFormattedNumber(debitTotalCreditor)}
                  </span>
                </Col>
                <Col lg={10} className="textEnd">
                  <span style={{ paddingRight: "12px" }}>
                    ₹ {Utils.getFormattedNumber(creditTotalCreditor)}
                  </span>
                </Col>
              </Row>
              <Divider className="my-5 grayBg" />
            </Col>
          </Row>
          {openModel.type === "addSupplier" && (
            <AddLedger
              openDrawer={true}
              id={""}
              setOpenDrawer={() => setOpenModel({ type: "", param: "" })}
              setTrigger={() => setTrigger(!trigger)}
              setAddLedgerResponse={setAddLedgerResponse}
              type={SearchLedgerByGroupsTypes.CreditorsOnly}
              showName="Supplier"
            />
          )}
        </div>
      ),
      extra: importModelSupplier(),
    },
    {
      key: "asset",
      label: "Asset",
      children: (
        <div style={{ padding: "2px", margin: "2px" }}>
          {openAssetModal.open && (
            <AddAssetItems
              onCancel={closeAssetModal}
              open={openAssetModal.open}
              oldPurchaseType={true}
              setAssetModelOpen={setOpenAssetModal}
              setTrigger={setAddAssetTrigger}
            ></AddAssetItems>
          )}
          {!isDisabled && (
            <>
              <div style={{ marginBottom: "20px" }}>
                {
                  <AssetChildItemsTable
                    setFixedAssetListPassToOpeningBalance={
                      setFixedAssetListPassToOpeningBalance
                    }
                    assetPurchaseType={true}
                    addAssetTrigger={addAssetTrigger}
                  />
                  // <AssteItemsTable
                  //   setFixedAssetListPassToOpeningBalance={
                  //     setFixedAssetListPassToOpeningBalance
                  //   }
                  //   assetPurchaseType={true}
                  // />
                }
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                  gap: 10,
                }}
              >
                {permissionFixedAssetAdd && (
                  <Button
                    onClick={() => showAssetModal()}
                    disabled={isDisabled}
                  >
                    <PlusOutlined /> Add Fixed Asset
                  </Button>
                )}
                <Button
                  onClick={handlePassFixedAssetsToForm}
                  disabled={
                    isDisabled || fixedAssetListPassToOpeningBalance.length < 1
                  }
                  // style={{ marginBottom: "10px" }}
                >
                  Pass Fixed Assets List to Opening Balance
                </Button>
              </div>
            </>
          )}
          <div style={{ padding: "0px 0px 3px 0px", width: "60%" }}>
            <Spin
              indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
              spinning={loading}
            >
              <Form
                form={fixedAssetform}
                autoComplete="off"
                name="openingBalanceForFixedAsset"
                disabled={isDisabled}
                initialValues={{
                  partyLedgerFixedAsset: [{}],
                }}
              >
                <div>
                  <table className="AddPageTabelDesign">
                    <thead>
                      <tr>
                        <th style={{ width: "60%" }}>Account</th>
                        <th style={{ width: "20%" }}>Debit</th>
                        <th colSpan={2} style={{ width: "20%" }}>
                          Credit
                        </th>
                      </tr>
                    </thead>
                    <Form.List name="partyLedgerFixedAsset">
                      {(fields, { add, remove }) => {
                        return (
                          <>
                            <tbody>
                              {fields.map(
                                (
                                  { key, name, ...restField }: any,
                                  index: number
                                ) => {
                                  return (
                                    <tr key={key}>
                                      <td>
                                        <Form.Item
                                          name={[name, "id"]}
                                          className="m-0"
                                          {...restField}
                                        >
                                          <Select
                                            labelInValue
                                            showSearch
                                            placeholder="Search to ledger"
                                            optionFilterProp="children"
                                            popupMatchSelectWidth={false}
                                            style={{ width: "100%" }}
                                            dropdownStyle={{
                                              width: "250px",
                                            }}
                                            placement="bottomRight"
                                            // onSearch={(value: string) =>
                                            //   setSearchItem(value)
                                            // }
                                            options={partyLedgerOptionFixedAsset
                                              .filter(
                                                (option) =>
                                                  !selectedPartyOptionFixedAsset.includes(
                                                    option.id
                                                  )
                                              )
                                              .map((option: any) => ({
                                                value: option?.id,
                                                label: option?.ledgerName,
                                                key: option?.id,
                                                // title: option?.partyOrTax,
                                              }))}
                                            filterOption={(input, option) =>
                                              (option?.label?.toString() ?? "")
                                                .toLowerCase()
                                                .includes(input.toLowerCase())
                                            }
                                            onChange={(e: any) => {
                                              // console.log("e", e);
                                              if (fields.length === index + 1) {
                                                add();
                                                updateTotals(
                                                  fixedAssetform,
                                                  "partyLedgerFixedAsset",
                                                  "FixedAssets"
                                                );
                                              } else {
                                                focusOnvalue(
                                                  index,
                                                  fixedAssetform,
                                                  "partyLedgerFixedAsset"
                                                );
                                              }
                                              //   partySelect(e.value, index, e.title);
                                              // onClickSelectPartyLedger(
                                              //   e.value,
                                              //   index,
                                              //   "FixedAssets"
                                              // );
                                              setSelectedPartyOptionFixedAsset(
                                                (prev) => [...prev, e.value]
                                              );
                                            }}
                                            dropdownRender={(
                                              customerOptions
                                            ) => (
                                              <>
                                                {customerOptions}
                                                {permissionLedgerAdd && (
                                                  <>
                                                    <Divider
                                                      style={{
                                                        margin: "5px 0px",
                                                      }}
                                                    />
                                                    <Button
                                                      style={{ width: "100%" }}
                                                      icon={<PlusOutlined />}
                                                      type="link"
                                                      onClick={() => {
                                                        setOpenModel({
                                                          type: "addAsset",
                                                          param: {
                                                            open: true,
                                                          },
                                                        });
                                                        // setEditParty({ id: "" });
                                                      }}
                                                    >
                                                      New Ledger
                                                    </Button>
                                                  </>
                                                )}
                                              </>
                                            )}
                                          />
                                        </Form.Item>
                                      </td>
                                      <td>
                                        <Form.Item
                                          name={[name, "debit"]}
                                          {...restField}
                                          className="m-0"
                                          initialValue={Utils.getFormattedNumber(
                                            0
                                          )}
                                        >
                                          <Input
                                            ref={(el) =>
                                              (debitRefs.current[index] = el)
                                            }
                                            disabled={
                                              isDisabled ||
                                              fields.length === index + 1
                                            }
                                            className="textEnd"
                                            onBlur={(e) =>
                                              Number(e.target.value) > 0 &&
                                              onDebitBlur(
                                                e.target.value,
                                                index,
                                                fixedAssetform,
                                                "partyLedgerFixedAsset",
                                                "FixedAssets"
                                              )
                                            }
                                            onChange={() =>
                                              handleTotalChange(
                                                fixedAssetform.getFieldValue([
                                                  "partyLedgerFixedAsset",
                                                ]),
                                                "FixedAssets"
                                              )
                                            }
                                          />
                                        </Form.Item>
                                      </td>
                                      <td style={{ width: "100%" }}>
                                        <Form.Item
                                          name={[name, "credit"]}
                                          {...restField}
                                          className="m-0"
                                          initialValue={Utils.getFormattedNumber(
                                            0
                                          )}
                                        >
                                          <Input
                                            ref={(el) =>
                                              (creditRefs.current[index] = el)
                                            }
                                            disabled={
                                              isDisabled ||
                                              fields.length === index + 1
                                            }
                                            className="textEnd"
                                            style={{}}
                                            onBlur={(e) =>
                                              Number(e.target.value) > 0 &&
                                              onCreditBlur(
                                                e.target.value,
                                                index,
                                                fixedAssetform,
                                                "partyLedgerFixedAsset",
                                                "FixedAssets"
                                              )
                                            }
                                            onChange={() =>
                                              handleTotalChange(
                                                fixedAssetform.getFieldValue([
                                                  "partyLedgerFixedAsset",
                                                ]),
                                                "FixedAssets"
                                              )
                                            }
                                          />
                                        </Form.Item>
                                      </td>
                                      <td style={{ width: 30 }}>
                                        {fields.length !== index + 1 && (
                                          <img
                                            alt="Delete"
                                            src={deleteImg}
                                            className="cursor mx-1"
                                            style={{
                                              backgroundColor: isDisabled
                                                ? "#f2f2f2"
                                                : "",
                                            }}
                                            onClick={() => {
                                              !isDisabled && setListIndex(name);
                                              !isDisabled &&
                                                setConfirmationFixedAsset(true);
                                              // if(){
                                              //   // setIsButtonDisabled(false);
                                              // }
                                            }}
                                          />
                                        )}
                                      </td>
                                    </tr>
                                  );
                                }
                              )}
                            </tbody>
                            {confirmationFixedAsset && (
                              <ConfirmationModal
                                open={confirmationFixedAsset}
                                text="Do you really want to delete this row ?"
                                onNo={() => setConfirmationFixedAsset(false)}
                                onYes={() => {
                                  const data = [
                                    ...fixedAssetform.getFieldValue(
                                      "partyLedgerFixedAsset"
                                    ),
                                  ];
                                  const rowsAccount =
                                    fixedAssetform.getFieldValue(
                                      "partyLedgerFixedAsset"
                                    )[listIndex].account;
                                  data.splice(listIndex, 1);
                                  if (rowsAccount) {
                                    setAccounts(
                                      accounts.map((group: ISelectGroup) => {
                                        return {
                                          ...group,
                                          options: group.options.map(
                                            (o: any) => {
                                              if (o.key === rowsAccount?.key) {
                                                return {
                                                  ...o,
                                                  disabled: false,
                                                };
                                              }
                                              return o;
                                            }
                                          ),
                                        };
                                      })
                                    );
                                  }
                                  remove(listIndex);
                                  handleTotalChange(data, "FixedAssets");
                                  setConfirmationFixedAsset(false);
                                  setSelectedPartyOptionFixedAsset((prev) => {
                                    const newDisabledInputs = [...prev];
                                    newDisabledInputs.splice(listIndex, 1);
                                    return newDisabledInputs;
                                  });
                                }}
                              />
                            )}
                          </>
                        );
                      }}
                    </Form.List>
                  </table>
                </div>
              </Form>
              <Row className=" pt-10 mt-14">
                <Col lg={12}></Col>
                <Col lg={12}>
                  <Row>
                    <Col lg={4}>Total</Col>
                    <Col lg={10} className="textEnd">
                      <span style={{ paddingRight: "12px" }}>
                        ₹ {Utils.getFormattedNumber(debitTotalFixedAsset)}
                      </span>
                    </Col>
                    <Col lg={10} className="textEnd">
                      <span style={{ paddingRight: "12px" }}>
                        ₹ {Utils.getFormattedNumber(creditTotalFixedAsset)}
                      </span>
                    </Col>
                  </Row>
                  <Divider className="my-5 grayBg" />
                </Col>
              </Row>
            </Spin>

            {/* {importModal?.type === "importModal" && (
              <ImportLedger
                onDismiss={(confirmed: boolean) => {
                  setImportModal({ type: "", param: {} });
                }}
                setImportedLedgers={setImportedLedgers}
                setTrigger={setTrigger}
              />
            )} */}
            {openModel.type === "addAsset" && (
              <AddLedger
                openDrawer={true}
                id={""}
                setOpenDrawer={() => setOpenModel({ type: "", param: "" })}
                setTrigger={() => setTrigger(!trigger)}
                setAddLedgerResponse={setAddLedgerResponse}
                type={SearchLedgerByGroupsTypes.FixedAssets}
                showName="Asset"
              />
            )}
          </div>
        </div>
      ),
      extra: (
        <Row style={{ gap: "50px", alignItems: "center" }} className="textEnd">
          <Row style={{ gap: "5px" }}>
            <Col> Debit : </Col>
            <Col className="fw-600">
              ₹ {Utils.getFormattedNumber(debitTotalFixedAsset)}
            </Col>
          </Row>
          <Row style={{ gap: "5px" }}>
            <Col> Credit : </Col>
            <Col className="fw-600">
              ₹ {Utils.getFormattedNumber(creditTotalFixedAsset)}
            </Col>
          </Row>
          <Col style={{ paddingRight: "30px" }}></Col>
        </Row>
      ),
    },
    {
      key: "otherAsset",
      label: "Asset Other Than Fixed Asset",
      children: (
        <div style={{ padding: "0px 0px 0px 0px", width: "60%" }}>
          <Spin
            indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
            spinning={loading}
          >
            <Form
              form={otherAssetform}
              autoComplete="off"
              name="openingBalanceForOtherAsset"
              disabled={isDisabled}
              initialValues={{
                partyLedgerOtherAsset: [{}],
              }}
            >
              <div>
                <table className="AddPageTabelDesign">
                  <thead>
                    <tr>
                      <th style={{ width: "60%" }}>Account</th>
                      <th style={{ width: "20%" }}>Debit</th>
                      <th colSpan={2} style={{ width: "20%" }}>
                        Credit
                      </th>
                    </tr>
                  </thead>
                  <Form.List name="partyLedgerOtherAsset">
                    {(fields, { add, remove }) => {
                      return (
                        <>
                          <tbody>
                            {fields.map(
                              ({ key, name, ...restField }, index) => {
                                return (
                                  <tr key={key}>
                                    <td>
                                      <Form.Item
                                        name={[name, "id"]}
                                        className="m-0"
                                        {...restField}
                                      >
                                        <Select
                                          labelInValue
                                          showSearch
                                          placeholder="Search to ledger"
                                          optionFilterProp="children"
                                          popupMatchSelectWidth={false}
                                          style={{ width: "100%" }}
                                          dropdownStyle={{
                                            width: "250px",
                                          }}
                                          placement="bottomRight"
                                          // onSearch={(value: string) =>
                                          //   setSearchItem(value)
                                          // }
                                          options={partyLedgerOptionOtherAsset
                                            .filter(
                                              (option) =>
                                                option.partyOrTax !==
                                                  Party_Tax.Stock &&
                                                !selectedPartyOptionOtherAsset.includes(
                                                  option.id
                                                )
                                            )
                                            .map((option: any) => ({
                                              value: option?.id,
                                              label: option?.ledgerName,
                                              title: option?.partyOrTax,
                                            }))}
                                          filterOption={(input, option) =>
                                            (option?.label?.toString() ?? "")
                                              .toLowerCase()
                                              .includes(input.toLowerCase())
                                          }
                                          onChange={(e: any) => {
                                            if (fields.length === index + 1) {
                                              add();
                                              updateTotals(
                                                otherAssetform,
                                                "partyLedgerOtherAsset",
                                                "OtherThanFixedAssets"
                                              );
                                            } else {
                                              focusOnvalue(
                                                index,
                                                otherAssetform,
                                                "partyLedgerOtherAsset"
                                              );
                                            }
                                            //   partySelect(e.value, index, e.title);
                                            onClickSelectPartyLedger(
                                              e.value,
                                              index,
                                              "OtherThanFixedAssets"
                                            );
                                          }}
                                          dropdownRender={(customerOptions) => (
                                            <>
                                              {customerOptions}
                                              {permissionLedgerAdd && (
                                                <>
                                                  <Divider
                                                    style={{
                                                      margin: "5px 0px",
                                                    }}
                                                  />
                                                  <Button
                                                    style={{ width: "100%" }}
                                                    icon={<PlusOutlined />}
                                                    type="link"
                                                    onClick={() => {
                                                      setOpenModel({
                                                        type: "addOtherAsset",
                                                        param: {
                                                          open: true,
                                                        },
                                                      });
                                                      // setEditParty({ id: "" });
                                                    }}
                                                  >
                                                    New Ledger
                                                  </Button>
                                                </>
                                              )}
                                            </>
                                          )}
                                        />
                                      </Form.Item>
                                    </td>
                                    <td>
                                      <Form.Item
                                        name={[name, "debit"]}
                                        {...restField}
                                        className="m-0"
                                        initialValue={Utils.getFormattedNumber(
                                          0
                                        )}
                                      >
                                        <Input
                                          ref={(el) =>
                                            (debitRefs.current[index] = el)
                                          }
                                          disabled={
                                            isDisabled ||
                                            fields.length === index + 1
                                          }
                                          className="textEnd"
                                          onBlur={(e) =>
                                            Number(e.target.value) > 0 &&
                                            onDebitBlur(
                                              e.target.value,
                                              index,
                                              otherAssetform,
                                              "partyLedgerOtherAsset",
                                              "OtherThanFixedAssets"
                                            )
                                          }
                                          onChange={() =>
                                            handleTotalChange(
                                              otherAssetform.getFieldValue([
                                                "partyLedgerOtherAsset",
                                              ]),
                                              "OtherThanFixedAssets"
                                            )
                                          }
                                        />
                                      </Form.Item>
                                    </td>
                                    <td style={{ width: "100%" }}>
                                      <Form.Item
                                        name={[name, "credit"]}
                                        {...restField}
                                        className="m-0"
                                        initialValue={Utils.getFormattedNumber(
                                          0
                                        )}
                                      >
                                        <Input
                                          ref={(el) =>
                                            (creditRefs.current[index] = el)
                                          }
                                          disabled={
                                            isDisabled ||
                                            fields.length === index + 1
                                          }
                                          className="textEnd"
                                          style={{}}
                                          onBlur={(e) =>
                                            Number(e.target.value) > 0 &&
                                            onCreditBlur(
                                              e.target.value,
                                              index,
                                              otherAssetform,
                                              "partyLedgerOtherAsset",
                                              "OtherThanFixedAssets"
                                            )
                                          }
                                          onChange={() =>
                                            handleTotalChange(
                                              otherAssetform.getFieldValue([
                                                "partyLedgerOtherAsset",
                                              ]),
                                              "OtherThanFixedAssets"
                                            )
                                          }
                                        />
                                      </Form.Item>
                                    </td>
                                    <td style={{ width: 30 }}>
                                      {fields.length !== index + 1 && (
                                        <img
                                          alt="Delete"
                                          src={deleteImg}
                                          className="cursor mx-1"
                                          style={{
                                            backgroundColor: isDisabled
                                              ? "#f2f2f2"
                                              : "",
                                          }}
                                          onClick={() => {
                                            !isDisabled && setListIndex(name);
                                            !isDisabled &&
                                              setConfirmationOtherAsset(true);
                                          }}
                                        />
                                      )}
                                    </td>
                                  </tr>
                                );
                              }
                            )}
                          </tbody>
                          {confirmationOtherAsset && (
                            <ConfirmationModal
                              open={confirmationOtherAsset}
                              text="Do you really want to delete this row ?"
                              onNo={() => setConfirmationOtherAsset(false)}
                              onYes={() => {
                                const data = [
                                  ...otherAssetform.getFieldValue(
                                    "partyLedgerOtherAsset"
                                  ),
                                ];
                                const rowsAccount =
                                  otherAssetform.getFieldValue(
                                    "partyLedgerOtherAsset"
                                  )[listIndex].account;
                                data.splice(listIndex, 1);
                                if (rowsAccount) {
                                  setAccounts(
                                    accounts.map((group: ISelectGroup) => {
                                      return {
                                        ...group,
                                        options: group.options.map((o: any) => {
                                          if (o.key === rowsAccount?.key) {
                                            return {
                                              ...o,
                                              disabled: false,
                                            };
                                          }
                                          return o;
                                        }),
                                      };
                                    })
                                  );
                                }
                                remove(listIndex);
                                handleTotalChange(data, "OtherThanFixedAssets");
                                setConfirmationOtherAsset(false);
                                setSelectedPartyOptionOtherAsset((prev) => {
                                  const newDisabledInputs = [...prev];
                                  newDisabledInputs.splice(listIndex, 1);
                                  return newDisabledInputs;
                                });
                              }}
                            />
                          )}
                        </>
                      );
                    }}
                  </Form.List>
                </table>
              </div>
            </Form>
            <Row className=" pt-10 mt-14">
              <Col lg={12}></Col>
              <Col lg={12}>
                <Row>
                  <Col lg={4}>Total</Col>
                  <Col lg={10} className="textEnd">
                    <span style={{ paddingRight: "12px" }}>
                      ₹ {Utils.getFormattedNumber(debitTotalOtherAsset)}
                    </span>
                  </Col>
                  <Col lg={10} className="textEnd">
                    <span style={{ paddingRight: "12px" }}>
                      ₹ {Utils.getFormattedNumber(creditTotalOtherAsset)}
                    </span>
                  </Col>
                </Row>
                <Divider className="my-5 grayBg" />
              </Col>
            </Row>
          </Spin>

          {/* {importModal?.type === "importModal" && (
            <ImportLedger
              onDismiss={(confirmed: boolean) => {
                setImportModal({ type: "", param: {} });
              }}
              setImportedLedgers={setImportedLedgers}
              setTrigger={setTrigger}
            />
          )} */}
          {openModel.type === "addOtherAsset" && (
            <AddLedger
              openDrawer={true}
              id={""}
              setOpenDrawer={() => setOpenModel({ type: "", param: "" })}
              setTrigger={() => setTrigger(!trigger)}
              setAddLedgerResponse={setAddLedgerResponse}
              type={SearchLedgerByGroupsTypes.AssetsOtherThanFixedAssets}
              // showName="Asset Other Than Fixed Asset"
              showName="Other Asset"
            />
          )}
        </div>
      ),
      extra: importModelOtherAsset(),
    },
    {
      key: "stock",
      label: "Stock",
      children: (
        <div style={{ padding: "2px", margin: "2px" }}>
          {openItemModal && (
            <AddItems
              open={openItemModal}
              onCancel={closeItemModal}
              oldItem={true}
              setTrigger={setAddItemTrigger}
            />
          )}
          {!isDisabled && (
            <>
              <div style={{ marginBottom: "20px" }}>
                {
                  <Items
                    itemPage={ItemType.All}
                    itemAddType={ItemAdd_Type.Opening}
                    setItemsListPassToOpeningBalance={
                      setItemsListPassToOpeningBalance
                    }
                    trigger={addItemTrigger}
                    oldItem={true}
                  />
                }
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                  gap: 10,
                }}
              >
                {permissionItemAdd && (
                  <Button onClick={() => setOpenItemModal(true)}>
                    <PlusOutlined /> Add Item
                  </Button>
                )}
                <Button
                  onClick={handlePassItemsToForm}
                  disabled={itemsListPassToOpeningBalance.length < 1}
                  // style={{ marginBottom: "10px" }}
                >
                  Pass Items List to Opening Balance
                </Button>
              </div>
            </>
          )}
          <div style={{ padding: "0px 0px 3px 0px", width: "60%" }}>
            <Spin
              indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
              spinning={loading}
            >
              <Form
                form={itemsform}
                autoComplete="off"
                name="openingBalanceForItems"
                disabled={isDisabled}
                initialValues={{
                  partyLedgerItems: [{}],
                }}
              >
                <div>
                  <table className="AddPageTabelDesign">
                    <thead>
                      <tr>
                        <th style={{ width: "60%" }}>Account</th>
                        <th style={{ width: "20%" }}>Debit</th>
                        <th colSpan={2} style={{ width: "20%" }}>
                          Credit
                        </th>
                      </tr>
                    </thead>
                    <Form.List name="partyLedgerItems">
                      {(fields, { add, remove }) => {
                        return (
                          <>
                            <tbody>
                              {fields.map(
                                (
                                  { key, name, ...restField }: any,
                                  index: number
                                ) => {
                                  return (
                                    <tr key={key}>
                                      <td>
                                        <Form.Item
                                          name={[name, "id"]}
                                          className="m-0"
                                          {...restField}
                                        >
                                          <Select
                                            disabled
                                            labelInValue
                                            showSearch
                                            placeholder="Search to items"
                                            optionFilterProp="children"
                                            popupMatchSelectWidth={false}
                                            style={{ width: "100%" }}
                                            dropdownStyle={{
                                              width: "250px",
                                            }}
                                            placement="bottomRight"
                                            // onSearch={(value: string) =>
                                            //   setSearchItem(value)
                                            // }
                                            options={partyLedgerOptionOtherAsset
                                              .filter(
                                                (option) =>
                                                  option.partyTax ===
                                                    Party_Tax.Stock &&
                                                  !selectedPartyOptionItems.includes(
                                                    option.id
                                                  )
                                              )
                                              .map((option: any) => ({
                                                value: option?.id,
                                                label: option?.ledgerName,
                                                title: option?.partyOrTax,
                                              }))}
                                            filterOption={(input, option) =>
                                              (option?.label?.toString() ?? "")
                                                .toLowerCase()
                                                .includes(input.toLowerCase())
                                            }
                                            onChange={(e: any) => {
                                              // console.log("e", e);
                                              if (fields.length === index + 1) {
                                                add();
                                                updateTotals(
                                                  itemsform,
                                                  "partyLedgerItems",
                                                  "Items"
                                                );
                                              } else {
                                                focusOnvalue(
                                                  index,
                                                  itemsform,
                                                  "partyLedgerItems"
                                                );
                                              }
                                              setSelectedPartyOptionItems(
                                                (prev) => [...prev, e.value]
                                              );
                                            }}
                                            // dropdownRender={(
                                            //   customerOptions
                                            // ) => (
                                            //   <>
                                            //     {customerOptions}
                                            //     <Divider
                                            //       style={{
                                            //         margin: "5px 0px",
                                            //       }}
                                            //     />
                                            //     <Button
                                            //       style={{ width: "100%" }}
                                            //       icon={<PlusOutlined />}
                                            //       type="link"
                                            //       onClick={() => {
                                            //         setOpenModel({
                                            //           type: "addAsset",
                                            //           param: {
                                            //             open: true,
                                            //           },
                                            //         });
                                            //         // setEditParty({ id: "" });
                                            //       }}
                                            //     >
                                            //       New Ledger
                                            //     </Button>
                                            //   </>
                                            // )}
                                          />
                                        </Form.Item>
                                      </td>
                                      <td>
                                        <Form.Item
                                          name={[name, "debit"]}
                                          {...restField}
                                          className="m-0"
                                          initialValue={Utils.getFormattedNumber(
                                            0
                                          )}
                                        >
                                          <Input
                                            disabled
                                            ref={(el) =>
                                              (debitRefs.current[index] = el)
                                            }
                                            className="textEnd"
                                            onBlur={(e) =>
                                              Number(e.target.value) > 0 &&
                                              onDebitBlur(
                                                e.target.value,
                                                index,
                                                itemsform,
                                                "partyLedgerItems",
                                                "Items"
                                              )
                                            }
                                            onChange={() =>
                                              handleTotalChange(
                                                itemsform.getFieldValue([
                                                  "partyLedgerItems",
                                                ]),
                                                "Items"
                                              )
                                            }
                                          />
                                        </Form.Item>
                                      </td>
                                      <td style={{ width: "100%" }}>
                                        <Form.Item
                                          name={[name, "credit"]}
                                          {...restField}
                                          className="m-0"
                                          initialValue={Utils.getFormattedNumber(
                                            0
                                          )}
                                        >
                                          <Input
                                            disabled
                                            ref={(el) =>
                                              (creditRefs.current[index] = el)
                                            }
                                            className="textEnd"
                                            style={{}}
                                            onBlur={(e) =>
                                              Number(e.target.value) > 0 &&
                                              onCreditBlur(
                                                e.target.value,
                                                index,
                                                itemsform,
                                                "partyLedgerItems",
                                                "Items"
                                              )
                                            }
                                            onChange={() =>
                                              handleTotalChange(
                                                itemsform.getFieldValue([
                                                  "partyLedgerItems",
                                                ]),
                                                "items"
                                              )
                                            }
                                          />
                                        </Form.Item>
                                      </td>
                                      <td style={{ width: 30 }}>
                                        {fields.length !== index + 1 && (
                                          <img
                                            alt="Delete"
                                            src={deleteImg}
                                            className="cursor mx-1"
                                            style={{
                                              backgroundColor: isDisabled
                                                ? "#f2f2f2"
                                                : "",
                                            }}
                                            onClick={() => {
                                              !isDisabled && setListIndex(name);
                                              !isDisabled &&
                                                setConfirmationItems(true);
                                            }}
                                          />
                                        )}
                                      </td>
                                    </tr>
                                  );
                                }
                              )}
                            </tbody>
                            {confirmationItems && (
                              <ConfirmationModal
                                open={confirmationItems}
                                text="Do you really want to delete this row ?"
                                onNo={() => setConfirmationItems(false)}
                                onYes={() => {
                                  const data = [
                                    ...itemsform.getFieldValue(
                                      "partyLedgerItems"
                                    ),
                                  ];
                                  const rowsAccount =
                                    itemsform.getFieldValue("partyLedgerItems")[
                                      listIndex
                                    ].account;
                                  data.splice(listIndex, 1);
                                  if (rowsAccount) {
                                    setAccounts(
                                      accounts.map((group: ISelectGroup) => {
                                        return {
                                          ...group,
                                          options: group.options.map(
                                            (o: any) => {
                                              if (o.key === rowsAccount?.key) {
                                                return {
                                                  ...o,
                                                  disabled: false,
                                                };
                                              }
                                              return o;
                                            }
                                          ),
                                        };
                                      })
                                    );
                                  }
                                  remove(listIndex);
                                  handleTotalChange(data, "Items");
                                  setConfirmationItems(false);
                                  setSelectedPartyOptionItems((prev) => {
                                    const newDisabledInputs = [...prev];
                                    newDisabledInputs.splice(listIndex, 1);
                                    return newDisabledInputs;
                                  });
                                }}
                              />
                            )}
                          </>
                        );
                      }}
                    </Form.List>
                  </table>
                </div>
              </Form>
              <Row className=" pt-10 mt-14">
                <Col lg={12}></Col>
                <Col lg={12}>
                  <Row>
                    <Col lg={4}>Total</Col>
                    <Col lg={10} className="textEnd">
                      <span style={{ paddingRight: "12px" }}>
                        ₹ {Utils.getFormattedNumber(debitTotalItems)}
                      </span>
                    </Col>
                    <Col lg={10} className="textEnd">
                      <span style={{ paddingRight: "12px" }}>
                        ₹ {Utils.getFormattedNumber(creditTotalItems)}
                      </span>
                    </Col>
                  </Row>
                  <Divider className="my-5 grayBg" />
                </Col>
              </Row>
            </Spin>
          </div>
        </div>
      ),
      extra: (
        <Row style={{ gap: "50px", alignItems: "center" }} className="textEnd">
          <Row style={{ gap: "5px" }}>
            <Col> Debit : </Col>
            <Col className="fw-600">
              ₹ {Utils.getFormattedNumber(debitTotalItems)}
            </Col>
          </Row>
          <Row style={{ gap: "5px" }}>
            <Col> Credit : </Col>
            <Col className="fw-600">
              ₹ {Utils.getFormattedNumber(creditTotalItems)}
            </Col>
          </Row>
          <Col style={{ paddingRight: "30px" }}></Col>
        </Row>
      ),
    },
    {
      key: "liability",
      label: "Liability",
      children: (
        <div style={{ padding: "0px 0px 3px 0px", width: "60%" }}>
          <Spin
            indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
            spinning={loading}
          >
            <Form
              form={liabilityForm}
              autoComplete="off"
              name="openingBalanceForLiability"
              disabled={isDisabled}
              initialValues={{
                partyLedgerLiability: [{}],
              }}
            >
              <div>
                <table className="AddPageTabelDesign">
                  <thead>
                    <tr>
                      <th style={{ width: "60%" }}>Account</th>
                      <th style={{ width: "20%" }}>Debit</th>
                      <th colSpan={2} style={{ width: "20%" }}>
                        Credit
                      </th>
                    </tr>
                  </thead>
                  <Form.List name="partyLedgerLiability">
                    {(fields, { add, remove }) => {
                      return (
                        <>
                          <tbody>
                            {fields.map(
                              (
                                { key, name, ...restField }: any,
                                index: number
                              ) => {
                                return (
                                  <tr key={key}>
                                    <td>
                                      <Form.Item
                                        name={[name, "id"]}
                                        className="m-0"
                                        {...restField}
                                      >
                                        <Select
                                          labelInValue
                                          showSearch
                                          placeholder="Search to ledger"
                                          optionFilterProp="children"
                                          popupMatchSelectWidth={false}
                                          style={{ width: "100%" }}
                                          dropdownStyle={{
                                            width: "250px",
                                          }}
                                          placement="bottomRight"
                                          // onSearch={(value: string) =>
                                          //   setSearchItem(value)
                                          // }
                                          options={partyLedgerOptionLiability
                                            .filter(
                                              (option) =>
                                                !selectedPartyOptionLiability.includes(
                                                  option.id
                                                )
                                            )
                                            .map((option: any) => ({
                                              value: option?.id,
                                              label: option?.ledgerName,
                                              title: option?.partyOrTax,
                                            }))}
                                          filterOption={(input, option) =>
                                            (option?.label?.toString() ?? "")
                                              .toLowerCase()
                                              .includes(input.toLowerCase())
                                          }
                                          onChange={(e: any) => {
                                            if (fields.length === index + 1) {
                                              add();
                                              updateTotals(
                                                liabilityForm,
                                                "partyLedgerLiability",
                                                "LiabilityOtherThanCapital"
                                              );
                                            } else {
                                              focusOnvalue(
                                                index,
                                                liabilityForm,
                                                "partyLedgerLiability"
                                              );
                                            }
                                            //   partySelect(e.value, index, e.title);
                                            onClickSelectPartyLedger(
                                              e.value,
                                              index,
                                              "LiabilityOtherThanCapital"
                                            );
                                          }}
                                          dropdownRender={(customerOptions) => (
                                            <>
                                              {customerOptions}
                                              {permissionLedgerAdd && (
                                                <>
                                                  <Divider
                                                    style={{
                                                      margin: "5px 0px",
                                                    }}
                                                  />
                                                  <Button
                                                    style={{ width: "100%" }}
                                                    icon={<PlusOutlined />}
                                                    type="link"
                                                    onClick={() => {
                                                      setOpenModel({
                                                        type: "addLiability",
                                                        param: {
                                                          open: true,
                                                        },
                                                      });
                                                      // setEditParty({ id: "" });
                                                    }}
                                                  >
                                                    New Ledger
                                                  </Button>
                                                </>
                                              )}
                                            </>
                                          )}
                                        />
                                      </Form.Item>
                                    </td>
                                    <td>
                                      <Form.Item
                                        name={[name, "debit"]}
                                        {...restField}
                                        className="m-0"
                                        initialValue={Utils.getFormattedNumber(
                                          0
                                        )}
                                      >
                                        <Input
                                          ref={(el) =>
                                            (debitRefs.current[index] = el)
                                          }
                                          disabled={
                                            isDisabled ||
                                            fields.length === index + 1
                                          }
                                          className="textEnd"
                                          onBlur={(e) =>
                                            Number(e.target.value) > 0 &&
                                            onDebitBlur(
                                              e.target.value,
                                              index,
                                              liabilityForm,
                                              "partyLedgerLiability",
                                              "LiabilityOtherThanCapital"
                                            )
                                          }
                                          onChange={() =>
                                            handleTotalChange(
                                              liabilityForm.getFieldValue([
                                                "partyLedgerLiability",
                                              ]),
                                              "LiabilityOtherThanCapital"
                                            )
                                          }
                                        />
                                      </Form.Item>
                                    </td>
                                    <td style={{ width: "100%" }}>
                                      <Form.Item
                                        name={[name, "credit"]}
                                        {...restField}
                                        className="m-0"
                                        initialValue={Utils.getFormattedNumber(
                                          0
                                        )}
                                      >
                                        <Input
                                          ref={(el) =>
                                            (creditRefs.current[index] = el)
                                          }
                                          disabled={
                                            isDisabled ||
                                            fields.length === index + 1
                                          }
                                          className="textEnd"
                                          style={{}}
                                          onBlur={(e) =>
                                            Number(e.target.value) > 0 &&
                                            onCreditBlur(
                                              e.target.value,
                                              index,
                                              liabilityForm,
                                              "partyLedgerLiability",
                                              "LiabilityOtherThanCapital"
                                            )
                                          }
                                          onChange={() =>
                                            handleTotalChange(
                                              liabilityForm.getFieldValue([
                                                "partyLedgerLiability",
                                              ]),
                                              "LiabilityOtherThanCapital"
                                            )
                                          }
                                        />
                                      </Form.Item>
                                    </td>
                                    <td style={{ width: 30 }}>
                                      {fields.length !== index + 1 && (
                                        <img
                                          alt="Delete"
                                          src={deleteImg}
                                          className="cursor mx-1"
                                          style={{
                                            backgroundColor: isDisabled
                                              ? "#f2f2f2"
                                              : "",
                                          }}
                                          onClick={() => {
                                            !isDisabled && setListIndex(name);
                                            !isDisabled &&
                                              setConfirmationLiability(true);
                                          }}
                                        />
                                      )}
                                    </td>
                                  </tr>
                                );
                              }
                            )}
                          </tbody>
                          {confirmationLiability && (
                            <ConfirmationModal
                              open={confirmationLiability}
                              text="Do you really want to delete this row ?"
                              onNo={() => setConfirmationLiability(false)}
                              onYes={() => {
                                const data = [
                                  ...liabilityForm.getFieldValue(
                                    "partyLedgerLiability"
                                  ),
                                ];
                                const rowsAccount = liabilityForm.getFieldValue(
                                  "partyLedgerLiability"
                                )[listIndex].account;
                                data.splice(listIndex, 1);
                                if (rowsAccount) {
                                  setAccounts(
                                    accounts.map((group: ISelectGroup) => {
                                      return {
                                        ...group,
                                        options: group.options.map((o: any) => {
                                          if (o.key === rowsAccount?.key) {
                                            return {
                                              ...o,
                                              disabled: false,
                                            };
                                          }
                                          return o;
                                        }),
                                      };
                                    })
                                  );
                                }
                                remove(listIndex);
                                handleTotalChange(
                                  data,
                                  "LiabilityOtherThanCapital"
                                );
                                setConfirmationLiability(false);
                                setSelectedPartyOptionLiability((prev) => {
                                  const newDisabledInputs = [...prev];
                                  newDisabledInputs.splice(listIndex, 1);
                                  return newDisabledInputs;
                                });
                              }}
                            />
                          )}
                        </>
                      );
                    }}
                  </Form.List>
                </table>
              </div>
            </Form>
            <Row className=" pt-10 mt-14">
              <Col lg={12}></Col>
              <Col lg={12}>
                <Row>
                  <Col lg={4}>Total</Col>
                  <Col lg={10} className="textEnd">
                    <span style={{ paddingRight: "12px" }}>
                      ₹ {Utils.getFormattedNumber(debitTotalLiability)}
                    </span>
                  </Col>
                  <Col lg={10} className="textEnd">
                    <span style={{ paddingRight: "12px" }}>
                      ₹ {Utils.getFormattedNumber(creditTotalLiability)}
                    </span>
                  </Col>
                </Row>
                <Divider className="my-5 grayBg" />
              </Col>
            </Row>
          </Spin>

          {/* {importModal?.type === "importModal" && (
            <ImportLedger
              onDismiss={(confirmed: boolean) => {
                setImportModal({ type: "", param: {} });
              }}
              setImportedLedgers={setImportedLedgers}
              setTrigger={setTrigger}
            />
          )} */}
          {openModel.type === "addLiability" && (
            <AddLedger
              openDrawer={true}
              id={""}
              setOpenDrawer={() => setOpenModel({ type: "", param: "" })}
              setTrigger={() => setTrigger(!trigger)}
              setAddLedgerResponse={setAddLedgerResponse}
              type={SearchLedgerByGroupsTypes.LiabilitiesOtherThanCapital}
              showName="Liability"
            />
          )}
        </div>
      ),
      extra: (
        <Row style={{ gap: "50px", alignItems: "center" }} className="">
          <Row style={{ gap: "5px" }}>
            <Col> Debit : </Col>
            <Col className="fw-600 ">
              ₹ {Utils.getFormattedNumber(debitTotalLiability)}
            </Col>
          </Row>

          <Row style={{ gap: "5px" }}>
            <Col> Credit : </Col>
            <Col className="fw-600">
              ₹ {Utils.getFormattedNumber(creditTotalLiability)}
            </Col>
          </Row>
          <Col style={{ paddingRight: "30px" }}></Col>
        </Row>
      ),
    },
    {
      key: "cashnbank",
      label: "Cash & Bank",
      children: (
        <div style={{ padding: "0px 0px 3px 0px", width: "60%" }}>
          <Spin
            indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
            spinning={loading}
          >
            <Form
              form={cashAndBankForm}
              autoComplete="off"
              name="openingBalanceForCashAndBank"
              disabled={isDisabled}
              initialValues={{
                partyLedgerCashAndBank: [{}],
              }}
            >
              <div>
                <table className="AddPageTabelDesign">
                  <thead>
                    <tr>
                      <th style={{ width: "60%" }}>Account</th>
                      <th style={{ width: "20%" }}>Debit</th>
                      <th colSpan={2} style={{ width: "20%" }}>
                        Credit
                      </th>
                    </tr>
                  </thead>
                  <Form.List name="partyLedgerCashAndBank">
                    {(fields, { add, remove }) => {
                      return (
                        <>
                          <tbody>
                            {fields.map(
                              (
                                { key, name, ...restField }: any,
                                index: number
                              ) => {
                                return (
                                  <tr key={key}>
                                    <td>
                                      <Form.Item
                                        name={[name, "id"]}
                                        className="m-0"
                                        {...restField}
                                      >
                                        <Select
                                          labelInValue
                                          showSearch
                                          placeholder="Search to items"
                                          optionFilterProp="children"
                                          popupMatchSelectWidth={false}
                                          style={{ width: "100%" }}
                                          dropdownStyle={{
                                            width: "250px",
                                          }}
                                          placement="bottomRight"
                                          // onSearch={(value: string) =>
                                          //   setSearchItem(value)
                                          // }
                                          options={partyLedgerOptionCashAndBank
                                            .filter(
                                              (option) =>
                                                !selectedPartyOptionCashAndBank.includes(
                                                  option.id
                                                )
                                            )
                                            .map((option: any) => ({
                                              value: option?.id,
                                              label: option?.ledgerName,
                                              title: option?.partyOrTax,
                                            }))}
                                          filterOption={(input, option) =>
                                            (option?.label?.toString() ?? "")
                                              .toLowerCase()
                                              .includes(input.toLowerCase())
                                          }
                                          onChange={(e: any) => {
                                            if (fields.length === index + 1) {
                                              add();
                                              updateTotals(
                                                cashAndBankForm,
                                                "partyLedgerCashAndBank",
                                                "CashnBank"
                                              );
                                            } else {
                                              focusOnvalue(
                                                index,
                                                cashAndBankForm,
                                                "partyLedgerCashAndBank"
                                              );
                                            }
                                            //   partySelect(e.value, index, e.title);
                                            onClickSelectPartyLedger(
                                              e.value,
                                              index,
                                              "CashnBank"
                                            );
                                          }}
                                          dropdownRender={(customerOptions) => (
                                            <>
                                              {customerOptions}
                                              {(permissionBankAdd ||
                                                permissionCashAdd) && (
                                                <>
                                                  <Divider
                                                    style={{
                                                      margin: "5px 0px",
                                                    }}
                                                  />
                                                  <Button
                                                    style={{ width: "100%" }}
                                                    icon={<PlusOutlined />}
                                                    type="link"
                                                    onClick={() => {
                                                      setOpenModel({
                                                        type: "addCashAndBank",
                                                        param: {
                                                          open: true,
                                                        },
                                                      });
                                                      // setEditParty({ id: "" });
                                                    }}
                                                  >
                                                    New Ledger
                                                  </Button>
                                                </>
                                              )}
                                            </>
                                          )}
                                        />
                                      </Form.Item>
                                    </td>
                                    <td>
                                      <Form.Item
                                        name={[name, "debit"]}
                                        {...restField}
                                        className="m-0"
                                        initialValue={Utils.getFormattedNumber(
                                          0
                                        )}
                                      >
                                        <Input
                                          ref={(el) =>
                                            (debitRefs.current[index] = el)
                                          }
                                          disabled={
                                            isDisabled ||
                                            fields.length === index + 1
                                          }
                                          className="textEnd"
                                          onBlur={(e) =>
                                            Number(e.target.value) > 0 &&
                                            onDebitBlur(
                                              e.target.value,
                                              index,
                                              cashAndBankForm,
                                              "partyLedgerCashAndBank",
                                              "CashnBank"
                                            )
                                          }
                                          onChange={() =>
                                            handleTotalChange(
                                              cashAndBankForm.getFieldValue([
                                                "partyLedgerCashAndBank",
                                              ]),
                                              "CashnBank"
                                            )
                                          }
                                        />
                                      </Form.Item>
                                    </td>
                                    <td style={{ width: "100%" }}>
                                      <Form.Item
                                        name={[name, "credit"]}
                                        {...restField}
                                        className="m-0"
                                        initialValue={Utils.getFormattedNumber(
                                          0
                                        )}
                                      >
                                        <Input
                                          ref={(el) =>
                                            (creditRefs.current[index] = el)
                                          }
                                          disabled={
                                            isDisabled ||
                                            fields.length === index + 1
                                          }
                                          className="textEnd"
                                          style={{}}
                                          onBlur={(e) =>
                                            Number(e.target.value) > 0 &&
                                            onCreditBlur(
                                              e.target.value,
                                              index,
                                              cashAndBankForm,
                                              "partyLedgerCashAndBank",
                                              "CashnBank"
                                            )
                                          }
                                          onChange={() =>
                                            handleTotalChange(
                                              cashAndBankForm.getFieldValue([
                                                "partyLedgerCashAndBank",
                                              ]),
                                              "CashnBank"
                                            )
                                          }
                                        />
                                      </Form.Item>
                                    </td>
                                    <td style={{ width: 30 }}>
                                      {fields.length !== index + 1 && (
                                        <img
                                          alt="Delete"
                                          src={deleteImg}
                                          className="cursor mx-1"
                                          style={{
                                            backgroundColor: isDisabled
                                              ? "#f2f2f2"
                                              : "",
                                          }}
                                          onClick={() => {
                                            !isDisabled && setListIndex(name);
                                            !isDisabled &&
                                              setConfirmationCashAndBank(true);
                                          }}
                                        />
                                      )}
                                    </td>
                                  </tr>
                                );
                              }
                            )}
                          </tbody>
                          {confirmationCashAndBank && (
                            <ConfirmationModal
                              open={confirmationCashAndBank}
                              text="Do you really want to delete this row ?"
                              onNo={() => setConfirmationCashAndBank(false)}
                              onYes={() => {
                                const data = [
                                  ...cashAndBankForm.getFieldValue(
                                    "partyLedgerCashAndBank"
                                  ),
                                ];
                                const rowsAccount =
                                  cashAndBankForm.getFieldValue(
                                    "partyLedgerCashAndBank"
                                  )[listIndex].account;
                                data.splice(listIndex, 1);
                                if (rowsAccount) {
                                  setAccounts(
                                    accounts.map((group: ISelectGroup) => {
                                      return {
                                        ...group,
                                        options: group.options.map((o: any) => {
                                          if (o.key === rowsAccount?.key) {
                                            return {
                                              ...o,
                                              disabled: false,
                                            };
                                          }
                                          return o;
                                        }),
                                      };
                                    })
                                  );
                                }
                                remove(listIndex);
                                handleTotalChange(data, "CashnBank");
                                setConfirmationCashAndBank(false);
                                setSelectedPartyOptionCashAndBank((prev) => {
                                  const newDisabledInputs = [...prev];
                                  newDisabledInputs.splice(listIndex, 1);
                                  return newDisabledInputs;
                                });
                              }}
                            />
                          )}
                        </>
                      );
                    }}
                  </Form.List>
                </table>
              </div>
            </Form>
            <Row className=" pt-10 mt-14">
              <Col lg={12}></Col>
              <Col lg={12}>
                <Row>
                  <Col lg={4}>Total</Col>
                  <Col lg={10} className="textEnd">
                    <span style={{ paddingRight: "12px" }}>
                      ₹ {Utils.getFormattedNumber(debitTotalCashAndBank)}
                    </span>
                  </Col>
                  <Col lg={10} className="textEnd">
                    <span style={{ paddingRight: "12px" }}>
                      ₹ {Utils.getFormattedNumber(creditTotalCashAndBank)}
                    </span>
                  </Col>
                </Row>
                <Divider className="my-5 grayBg" />
              </Col>
            </Row>
          </Spin>

          {/* {importModal?.type === "importModal" && (
            <ImportLedger
              onDismiss={(confirmed: boolean) => {
                setImportModal({ type: "", param: {} });
              }}
              setImportedLedgers={setImportedLedgers}
              setTrigger={setTrigger}
            />
          )} */}
          {openModel.type === "addCashAndBank" && (
            <AddLedger
              openDrawer={true}
              id={""}
              setOpenDrawer={() => setOpenModel({ type: "", param: "" })}
              setTrigger={() => setTrigger(!trigger)}
              setAddLedgerResponse={setAddLedgerResponse}
              type={SearchLedgerByGroupsTypes.BankAndCash}
              showName="Cash and Bank"
            />
          )}
        </div>
      ),
      extra: (
        <Row style={{ gap: "50px", alignItems: "center" }} className="textEnd">
          <Row style={{ gap: "5px" }}>
            <Col>Debit : </Col>{" "}
            <Col className="fw-600">
              ₹ {Utils.getFormattedNumber(debitTotalCashAndBank)}
            </Col>
          </Row>
          <Row style={{ gap: "5px" }}>
            <Col>Credit : </Col>
            <Col className="fw-600">
              {" "}
              ₹ {Utils.getFormattedNumber(creditTotalCashAndBank)}
            </Col>
          </Row>
          <Col style={{ paddingRight: "30px" }}></Col>
        </Row>
      ),
    },
    {
      key: "capital",
      label: "Capital",
      children: (
        <div style={{ padding: "0px 0px 3px 0px", width: "60%" }}>
          <Spin
            indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
            spinning={loading}
          >
            <Form
              form={capitalForm}
              autoComplete="off"
              name="openingBalanceForCapital"
              disabled={isDisabled}
              initialValues={{
                partyLedgerCapital: [{}],
              }}
            >
              <div>
                <table className="AddPageTabelDesign">
                  <thead>
                    <tr>
                      <th style={{ width: "60%" }}>Account</th>
                      <th style={{ width: "20%" }}>Debit</th>
                      <th colSpan={2} style={{ width: "20%" }}>
                        Credit
                      </th>
                    </tr>
                  </thead>
                  <Form.List name="partyLedgerCapital">
                    {(fields, { add, remove }) => {
                      return (
                        <>
                          <tbody>
                            {fields.map(
                              (
                                { key, name, ...restField }: any,
                                index: number
                              ) => {
                                return (
                                  <tr key={key}>
                                    <td>
                                      <Form.Item
                                        name={[name, "id"]}
                                        className="m-0"
                                        {...restField}
                                      >
                                        <Select
                                          labelInValue
                                          showSearch
                                          placeholder="Search to ledger"
                                          optionFilterProp="children"
                                          popupMatchSelectWidth={false}
                                          style={{ width: "100%" }}
                                          dropdownStyle={{
                                            width: "250px",
                                          }}
                                          placement="bottomRight"
                                          // onSearch={(value: string) =>
                                          //   setSearchItem(value)
                                          // }
                                          options={partyLedgerOptionCapital
                                            .filter(
                                              (option) =>
                                                !selectedPartyOptionCapital.includes(
                                                  option.id
                                                )
                                            )
                                            .map((option: any) => ({
                                              value: option?.id,
                                              label: option?.ledgerName,
                                              title: option?.partyOrTax,
                                            }))}
                                          filterOption={(input, option) =>
                                            (option?.label?.toString() ?? "")
                                              .toLowerCase()
                                              .includes(input.toLowerCase())
                                          }
                                          onChange={(e: any) => {
                                            if (fields.length === index + 1) {
                                              add();
                                              updateTotals(
                                                capitalForm,
                                                "partyLedgerCapital",
                                                "Capital"
                                              );
                                            } else {
                                              focusOnvalue(
                                                index,
                                                capitalForm,
                                                "partyLedgerCapital"
                                              );
                                            }
                                            //   partySelect(e.value, index, e.title);
                                            onClickSelectPartyLedger(
                                              e.value,
                                              index,
                                              "Capital"
                                            );
                                          }}
                                          dropdownRender={(customerOptions) => (
                                            <>
                                              {customerOptions}
                                              {permissionLedgerAdd && (
                                                <>
                                                  <Divider
                                                    style={{
                                                      margin: "5px 0px",
                                                    }}
                                                  />
                                                  <Button
                                                    style={{ width: "100%" }}
                                                    icon={<PlusOutlined />}
                                                    type="link"
                                                    onClick={() => {
                                                      setOpenModel({
                                                        type: "addCapital",
                                                        param: {
                                                          open: true,
                                                        },
                                                      });
                                                      // setEditParty({ id: "" });
                                                    }}
                                                  >
                                                    New Ledger
                                                  </Button>
                                                </>
                                              )}
                                            </>
                                          )}
                                        />
                                      </Form.Item>
                                    </td>
                                    <td>
                                      <Form.Item
                                        name={[name, "debit"]}
                                        {...restField}
                                        className="m-0"
                                        initialValue={Utils.getFormattedNumber(
                                          0
                                        )}
                                      >
                                        <Input
                                          ref={(el) =>
                                            (debitRefs.current[index] = el)
                                          }
                                          disabled={
                                            isDisabled ||
                                            fields.length === index + 1
                                          }
                                          className="textEnd"
                                          onBlur={(e) =>
                                            Number(e.target.value) > 0 &&
                                            onDebitBlur(
                                              e.target.value,
                                              index,
                                              capitalForm,
                                              "partyLedgerCapital",
                                              "Capital"
                                            )
                                          }
                                          onChange={() =>
                                            handleTotalChange(
                                              capitalForm.getFieldValue([
                                                "partyLedgerCapital",
                                              ]),
                                              "Capital"
                                            )
                                          }
                                        />
                                      </Form.Item>
                                    </td>
                                    <td style={{ width: "100%" }}>
                                      <Form.Item
                                        name={[name, "credit"]}
                                        {...restField}
                                        className="m-0"
                                        initialValue={Utils.getFormattedNumber(
                                          0
                                        )}
                                      >
                                        <Input
                                          ref={(el) =>
                                            (creditRefs.current[index] = el)
                                          }
                                          disabled={
                                            isDisabled ||
                                            fields.length === index + 1
                                          }
                                          className="textEnd"
                                          style={{}}
                                          onBlur={(e) =>
                                            Number(e.target.value) > 0 &&
                                            onCreditBlur(
                                              e.target.value,
                                              index,
                                              capitalForm,
                                              "partyLedgerCapital",
                                              "Capital"
                                            )
                                          }
                                          onChange={() =>
                                            handleTotalChange(
                                              capitalForm.getFieldValue([
                                                "partyLedgerCapital",
                                              ]),
                                              "Capital"
                                            )
                                          }
                                        />
                                      </Form.Item>
                                    </td>
                                    <td style={{ width: 30 }}>
                                      {fields.length !== index + 1 && (
                                        <img
                                          alt="Delete"
                                          src={deleteImg}
                                          className="cursor mx-1"
                                          style={{
                                            backgroundColor: isDisabled
                                              ? "#f2f2f2"
                                              : "",
                                          }}
                                          onClick={() => {
                                            !isDisabled && setListIndex(name);
                                            !isDisabled &&
                                              setConfirmationCapital(true);
                                          }}
                                        />
                                      )}
                                    </td>
                                  </tr>
                                );
                              }
                            )}
                          </tbody>
                          {confirmationCapital && (
                            <ConfirmationModal
                              open={confirmationCapital}
                              text="Do you really want to delete this row ?"
                              onNo={() => setConfirmationCapital(false)}
                              onYes={() => {
                                const data = [
                                  ...capitalForm.getFieldValue(
                                    "partyLedgerCapital"
                                  ),
                                ];
                                const rowsAccount =
                                  capitalForm.getFieldValue(
                                    "partyLedgerCapital"
                                  )[listIndex].account;
                                data.splice(listIndex, 1);
                                if (rowsAccount) {
                                  setAccounts(
                                    accounts.map((group: ISelectGroup) => {
                                      return {
                                        ...group,
                                        options: group.options.map((o: any) => {
                                          if (o.key === rowsAccount?.key) {
                                            return {
                                              ...o,
                                              disabled: false,
                                            };
                                          }
                                          return o;
                                        }),
                                      };
                                    })
                                  );
                                }
                                remove(listIndex);
                                handleTotalChange(data, "Capital");
                                setConfirmationCapital(false);
                                setSelectedPartyOptionCapital((prev) => {
                                  const newDisabledInputs = [...prev];
                                  newDisabledInputs.splice(listIndex, 1);
                                  return newDisabledInputs;
                                });
                              }}
                            />
                          )}
                        </>
                      );
                    }}
                  </Form.List>
                </table>
              </div>
            </Form>
            <Row className=" pt-10 mt-14">
              <Col lg={12}></Col>
              <Col lg={12}>
                <Row>
                  <Col lg={4}>Total</Col>
                  <Col lg={10} className="textEnd">
                    <span style={{ paddingRight: "12px" }}>
                      ₹ {Utils.getFormattedNumber(debitTotalCapital)}
                    </span>
                  </Col>
                  <Col lg={10} className="textEnd">
                    <span style={{ paddingRight: "12px" }}>
                      ₹ {Utils.getFormattedNumber(creditTotalCapital)}
                    </span>
                  </Col>
                </Row>
                <Divider className="my-5 grayBg" />
              </Col>
            </Row>
          </Spin>

          {/* {importModal?.type === "importModal" && (
            <ImportLedger
              onDismiss={(confirmed: boolean) => {
                setImportModal({ type: "", param: {} });
              }}
              setImportedLedgers={setImportedLedgers}
              setTrigger={setTrigger}
            />
          )} */}
          {openModel.type === "addCapital" && (
            <AddLedger
              openDrawer={true}
              id={""}
              setOpenDrawer={() => setOpenModel({ type: "", param: "" })}
              setTrigger={() => setTrigger(!trigger)}
              setAddLedgerResponse={setAddLedgerResponse}
              type={SearchLedgerByGroupsTypes.CapitalOnly}
              showName="Capital"
            />
          )}
        </div>
      ),
      extra: (
        <Row style={{ gap: "50px", alignItems: "center" }} className="textEnd">
          <Row style={{ gap: "5px" }}>
            <Col>Debit : </Col>
            <Col className="fw-600">
              ₹ {Utils.getFormattedNumber(debitTotalCapital)}
            </Col>
          </Row>
          <Row style={{ gap: "5px" }}>
            <Col>Credit : </Col>
            <Col className="fw-600">
              ₹ {Utils.getFormattedNumber(creditTotalCapital)}
            </Col>
          </Row>
          <Col style={{ paddingRight: "30px" }}></Col>
        </Row>
      ),
    },
  ];

  const totalAmountDebit = Math.round(
    debitTotalCreditor +
      debitTotalDebitor +
      debitTotalFixedAsset +
      debitTotalItems +
      debitTotalOtherAsset +
      debitTotalLiability +
      debitTotalCashAndBank +
      debitTotalCapital
  );

  const totalAmountCredit = Math.round(
    creditTotalCreditor +
      creditTotalDebitor +
      creditTotalFixedAsset +
      creditTotalItems +
      creditTotalOtherAsset +
      creditTotalLiability +
      creditTotalCashAndBank +
      creditTotalCapital
  );
  console.log("Client Detail: ", currentClient);

  return (
    <Spin spinning={loading}>
      <div>
        <Row justify={"space-between"} style={{ marginBottom: "15px" }}>
          <Col className="dashedBoxStyle">
            <Space>
              <span>Opening Balance as on</span>
              <Form
                form={dateForm}
                autoComplete="off"
                name="date"
                initialValues={{
                  date: dayjs(companySettings?.period.from),
                  // date: dayjs(companySettings?.period?.from),
                }}
              >
                <Form.Item
                  className="m-0"
                  name="date"
                  rules={[{ required: true, message: "Select a date" }]}
                >
                  <DatePicker
                    disabled
                    format={"DD/MM/YYYY"}
                    disabledDate={(current) =>
                      current < dayjs("1900-01-01", "YYYY-MM-DD").add(-1, "day")
                    }
                  />
                </Form.Item>
              </Form>
            </Space>
          </Col>
        </Row>
        <Card
          size="small"
          // className="TableCard"
          style={{
            marginTop: 5,
            borderRadius: 0,
            boxShadow: "0px 0px 4px 0px #96A1C84D",
            overflowY: "scroll",
            height: "60vh",
          }}
        >
          <Collapse items={items} />
        </Card>
        <Card style={{ margin: "15px 0px", position: "sticky" }}>
          <Row>
            <Col span={6}>
              <TextArea
                autoSize={{ minRows: 2, maxRows: 4 }}
                placeholder="Write narration"
              ></TextArea>
            </Col>
            <Col span={9}>
              <p style={{ fontWeight: "600", justifySelf: "flex-end" }}>
                Total Amount
              </p>
            </Col>
            <Col span={4}>
              <p style={{ justifySelf: "flex-end" }}>
                ₹ {Utils.getFormattedNumber(totalAmountDebit)}
              </p>
            </Col>
            <Col span={4}>
              <p style={{ justifySelf: "flex-end" }}>
                ₹ {Utils.getFormattedNumber(totalAmountCredit)}
              </p>
              {(totalAmountCredit !== 0 || totalAmountDebit !== 0) && (
                <div className="textEnd py-10 ms-0">
                  Status :{" "}
                  <Tag
                    bordered={true}
                    color={
                      totalAmountCredit === totalAmountDebit ? "green" : "red"
                    }
                    className="m-0"
                  >
                    {totalAmountCredit === totalAmountDebit
                      ? "Balanced"
                      : "Unbalanced"}
                  </Tag>
                </div>
              )}
              {!isDisabled && (
                <Button
                  type="primary"
                  style={{ float: "right" }}
                  icon={<SaveOutlined />}
                  disabled={
                    totalAmountCredit === totalAmountDebit &&
                    totalAmountCredit !== 0 &&
                    totalAmountDebit !== 0 &&
                    !isDisabled
                      ? false
                      : true
                  }
                  loading={saveButtonLoading}
                  onClick={() => AddOpeningBalance()}
                >
                  {journalId ? "Update" : "Save"}
                </Button>
              )}
              {isDisabled && (
                <Button
                  type="primary"
                  style={{ float: "right" }}
                  icon={<EditOutlined />}
                  onClick={() => {
                    setDisabled(false);
                    capitalForm.setFieldValue("partyLedgerCapital", [
                      ...capitalForm.getFieldValue("partyLedgerCapital"),
                      {},
                    ]);
                    cashAndBankForm.setFieldValue("partyLedgerCashAndBank", [
                      ...cashAndBankForm.getFieldValue(
                        "partyLedgerCashAndBank"
                      ),
                      {},
                    ]);
                    liabilityForm.setFieldValue("partyLedgerLiability", [
                      ...liabilityForm.getFieldValue("partyLedgerLiability"),
                      {},
                    ]);
                    otherAssetform.setFieldValue("partyLedgerOtherAsset", [
                      ...otherAssetform.getFieldValue("partyLedgerOtherAsset"),
                      {},
                    ]);
                    creditorform.setFieldValue("partyLedgerCreditor", [
                      ...creditorform.getFieldValue("partyLedgerCreditor"),
                      {},
                    ]);

                    debitorForm.setFieldValue("partyLedgerDebitor", [
                      ...debitorForm.getFieldValue("partyLedgerDebitor"),
                      {},
                    ]);
                  }}
                >
                  Edit
                </Button>
              )}
            </Col>
          </Row>
        </Card>
      </div>
    </Spin>
  );
};

export default SettingOpeningBalanceNew;
